(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["@zilliqa-js/util"] = {}));
})(this, (function (exports) { 'use strict';

  //  Copyright (C) 2018 Zilliqa
  //
  //  This file is part of zilliqa-js
  //
  //  This program is free software: you can redistribute it and/or modify
  //  it under the terms of the GNU General Public License as published by
  //  the Free Software Foundation, either version 3 of the License, or
  //  (at your option) any later version.
  //
  //  This program is distributed in the hope that it will be useful,
  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  //  GNU General Public License for more details.
  //
  //  You should have received a copy of the GNU General Public License
  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
  /**
   * intToHexArray
   *
   * @param {number} int - the number to be converted to hex
   * @param {number)} size - the desired width of the hex value. will pad.
   *
   * @returns {string[]}
   */
  var intToHexArray = function (int, size) {
      var hex = [];
      var hexRep = [];
      var hexVal = int.toString(16);
      // TODO: this really needs to be refactored.
      for (var i = 0; i < hexVal.length; i++) {
          hexRep[i] = hexVal[i].toString();
      }
      for (var i = 0; i < size - hexVal.length; i++) {
          hex.push('0');
      }
      for (var i = 0; i < hexVal.length; i++) {
          hex.push(hexRep[i]);
      }
      return hex;
  };
  /**
   * intToByteArray
   *
   * Converts a number to Uint8Array
   *
   * @param {number} num
   * @param {number} size
   *
   * @returns {Uint8Array}
   */
  var intToByteArray = function (num, size) {
      var x = num;
      var res = [];
      while (x > 0) {
          res.push(x & 255);
          x = x >> 8;
      }
      var pad = size - res.length;
      for (var i = 0; i < pad; i++) {
          res.unshift(0);
      }
      return Uint8Array.from(res);
  };
  /**
   * hexToByteArray
   *
   * Convers a hex string to a Uint8Array
   *
   * @param {string} hex
   * @returns {Uint8Array}
   */
  var hexToByteArray = function (hex) {
      var res = new Uint8Array(hex.length / 2);
      for (var i = 0; i < hex.length; i += 2) {
          res[i / 2] = parseInt(hex.substring(i, i + 2), 16);
      }
      return res;
  };
  /**
   * hexToIntArray
   *
   * @param {string} hex
   * @returns {number[]}
   */
  var hexToIntArray = function (hex) {
      if (!hex || !isHex(hex)) {
          return [];
      }
      var res = [];
      for (var i = 0; i < hex.length; i++) {
          var c = hex.charCodeAt(i);
          var hi = c >> 8;
          var lo = c & 0xff;
          hi ? res.push(hi, lo) : res.push(lo);
      }
      return res;
  };
  /**
   * pack
   *
   * Takes two 16-bit integers and combines them. Used to compute version.
   *
   * @param {number} a
   * @param {number} b
   *
   * @returns {number} - a 32-bit number
   */
  var pack = function (a, b) {
      if (a >> 16 > 0 || b >> 16 > 0) {
          throw new Error('Both a and b must be 16 bits or less');
      }
      return (a << 16) + b;
  };
  /**
   * compareBytes
   *
   * A constant time HMAC comparison function.
   *
   * @param {string} a
   * @param {string} b
   * @returns {boolean}
   */
  var isEqual = function (a, b) {
      var bzA = hexToIntArray(a);
      var bzB = hexToIntArray(b);
      if (bzA.length !== bzB.length) {
          return false;
      }
      var result = 0;
      for (var i = 0; i < bzA.length; i++) {
          result |= bzA[i] ^ bzB[i];
      }
      return result === 0;
  };
  /**
   * isHex
   *
   * @param {string} str - string to be tested
   * @returns {boolean}
   */
  var isHex = function (str) {
      var plain = str.replace('0x', '');
      return /[0-9a-f]*$/i.test(plain);
  };

  var bytes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    intToHexArray: intToHexArray,
    intToByteArray: intToByteArray,
    hexToByteArray: hexToByteArray,
    hexToIntArray: hexToIntArray,
    pack: pack,
    isEqual: isEqual,
    isHex: isHex
  });

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
  	if (typeof f == "function") {
  		var a = function a () {
  			if (this instanceof a) {
  				var args = [null];
  				args.push.apply(args, arguments);
  				var Ctor = Function.bind.apply(f, args);
  				return new Ctor();
  			}
  			return f.apply(this, arguments);
  		};
  		a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, '__esModule', {value: true});
  	Object.keys(n).forEach(function (k) {
  		var d = Object.getOwnPropertyDescriptor(n, k);
  		Object.defineProperty(a, k, d.get ? d : {
  			enumerable: true,
  			get: function () {
  				return n[k];
  			}
  		});
  	});
  	return a;
  }

  var bn = {exports: {}};

  var global$1 = (typeof global !== "undefined" ? global :
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window : {});

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var inited = false;
  function init () {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
  }

  function toByteArray (b64) {
    if (!inited) {
      init();
    }
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4')
    }

    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);

    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;

    var L = 0;

    for (i = 0, j = 0; i < l; i += 4, j += 3) {
      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
      arr[L++] = (tmp >> 16) & 0xFF;
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    if (placeHolders === 2) {
      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
      arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    return arr
  }

  function tripletToBase64 (num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
  }

  function encodeChunk (uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
      output.push(tripletToBase64(tmp));
    }
    return output.join('')
  }

  function fromByteArray (uint8) {
    if (!inited) {
      init();
    }
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3

    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    }

    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      output += lookup[tmp >> 2];
      output += lookup[(tmp << 4) & 0x3F];
      output += '==';
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
      output += lookup[tmp >> 10];
      output += lookup[(tmp >> 4) & 0x3F];
      output += lookup[(tmp << 2) & 0x3F];
      output += '=';
    }

    parts.push(output);

    return parts.join('')
  }

  function read (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? (nBytes - 1) : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];

    i += d;

    e = s & ((1 << (-nBits)) - 1);
    s >>= (-nBits);
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & ((1 << (-nBits)) - 1);
    e >>= (-nBits);
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : ((s ? -1 : 1) * Infinity)
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
  }

  function write (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    var i = isLE ? 0 : (nBytes - 1);
    var d = isLE ? 1 : -1;
    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = (e << mLen) | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  }

  var toString = {}.toString;

  var isArray = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };

  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */

  var INSPECT_MAX_BYTES = 50;

  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Use Object implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * Due to various browser bugs, sometimes the Object implementation will be used even
   * when the browser supports typed arrays.
   *
   * Note:
   *
   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
   *
   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
   *
   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
   *     incorrect length in some situations.

   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
   * get the Object implementation, which is slower but behaves correctly.
   */
  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    ? global$1.TYPED_ARRAY_SUPPORT
    : true;

  /*
   * Export kMaxLength after typed array support is determined.
   */
  var _kMaxLength = kMaxLength();

  function kMaxLength () {
    return Buffer.TYPED_ARRAY_SUPPORT
      ? 0x7fffffff
      : 0x3fffffff
  }

  function createBuffer (that, length) {
    if (kMaxLength() < length) {
      throw new RangeError('Invalid typed array length')
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = new Uint8Array(length);
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      if (that === null) {
        that = new Buffer(length);
      }
      that.length = length;
    }

    return that
  }

  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */

  function Buffer (arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
      return new Buffer(arg, encodingOrOffset, length)
    }

    // Common case.
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new Error(
          'If encoding is specified then the first argument must be a string'
        )
      }
      return allocUnsafe(this, arg)
    }
    return from(this, arg, encodingOrOffset, length)
  }

  Buffer.poolSize = 8192; // not used by this implementation

  // TODO: Legacy, not needed anymore. Remove in next major version.
  Buffer._augment = function (arr) {
    arr.__proto__ = Buffer.prototype;
    return arr
  };

  function from (that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('"value" argument must not be a number')
    }

    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
      return fromArrayBuffer(that, value, encodingOrOffset, length)
    }

    if (typeof value === 'string') {
      return fromString$1(that, value, encodingOrOffset)
    }

    return fromObject(that, value)
  }

  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/
  Buffer.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length)
  };

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species &&
        Buffer[Symbol.species] === Buffer) ;
  }

  function assertSize (size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be a number')
    } else if (size < 0) {
      throw new RangeError('"size" argument must not be negative')
    }
  }

  function alloc (that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(that, size)
    }
    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string'
        ? createBuffer(that, size).fill(fill, encoding)
        : createBuffer(that, size).fill(fill)
    }
    return createBuffer(that, size)
  }

  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/
  Buffer.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding)
  };

  function allocUnsafe (that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) {
      for (var i = 0; i < size; ++i) {
        that[i] = 0;
      }
    }
    return that
  }

  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */
  Buffer.allocUnsafe = function (size) {
    return allocUnsafe(null, size)
  };
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */
  Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size)
  };

  function fromString$1 (that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }

    if (!Buffer.isEncoding(encoding)) {
      throw new TypeError('"encoding" must be a valid string encoding')
    }

    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);

    var actual = that.write(string, encoding);

    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      that = that.slice(0, actual);
    }

    return that
  }

  function fromArrayLike (that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
      that[i] = array[i] & 255;
    }
    return that
  }

  function fromArrayBuffer (that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('\'offset\' is out of bounds')
    }

    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('\'length\' is out of bounds')
    }

    if (byteOffset === undefined && length === undefined) {
      array = new Uint8Array(array);
    } else if (length === undefined) {
      array = new Uint8Array(array, byteOffset);
    } else {
      array = new Uint8Array(array, byteOffset, length);
    }

    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = array;
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      that = fromArrayLike(that, array);
    }
    return that
  }

  function fromObject (that, obj) {
    if (internalIsBuffer(obj)) {
      var len = checked(obj.length) | 0;
      that = createBuffer(that, len);

      if (that.length === 0) {
        return that
      }

      obj.copy(that, 0, 0, len);
      return that
    }

    if (obj) {
      if ((typeof ArrayBuffer !== 'undefined' &&
          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
        if (typeof obj.length !== 'number' || isnan(obj.length)) {
          return createBuffer(that, 0)
        }
        return fromArrayLike(that, obj)
      }

      if (obj.type === 'Buffer' && isArray(obj.data)) {
        return fromArrayLike(that, obj.data)
      }
    }

    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
  }

  function checked (length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
    }
    return length | 0
  }

  function SlowBuffer (length) {
    if (+length != length) { // eslint-disable-line eqeqeq
      length = 0;
    }
    return Buffer.alloc(+length)
  }
  Buffer.isBuffer = isBuffer;
  function internalIsBuffer (b) {
    return !!(b != null && b._isBuffer)
  }

  Buffer.compare = function compare (a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
      throw new TypeError('Arguments must be Buffers')
    }

    if (a === b) return 0

    var x = a.length;
    var y = b.length;

    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  Buffer.isEncoding = function isEncoding (encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true
      default:
        return false
    }
  };

  Buffer.concat = function concat (list, length) {
    if (!isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }

    if (list.length === 0) {
      return Buffer.alloc(0)
    }

    var i;
    if (length === undefined) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }

    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (!internalIsBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }
      buf.copy(buffer, pos);
      pos += buf.length;
    }
    return buffer
  };

  function byteLength (string, encoding) {
    if (internalIsBuffer(string)) {
      return string.length
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
      return string.byteLength
    }
    if (typeof string !== 'string') {
      string = '' + string;
    }

    var len = string.length;
    if (len === 0) return 0

    // Use a for loop to avoid recursion
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len
        case 'utf8':
        case 'utf-8':
        case undefined:
          return utf8ToBytes(string).length
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2
        case 'hex':
          return len >>> 1
        case 'base64':
          return base64ToBytes(string).length
        default:
          if (loweredCase) return utf8ToBytes(string).length // assume utf8
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer.byteLength = byteLength;

  function slowToString (encoding, start, end) {
    var loweredCase = false;

    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.

    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
      start = 0;
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
      return ''
    }

    if (end === undefined || end > this.length) {
      end = this.length;
    }

    if (end <= 0) {
      return ''
    }

    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;

    if (end <= start) {
      return ''
    }

    if (!encoding) encoding = 'utf8';

    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end)

        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end)

        case 'ascii':
          return asciiSlice(this, start, end)

        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end)

        case 'base64':
          return base64Slice(this, start, end)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  }

  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
  // Buffer instances.
  Buffer.prototype._isBuffer = true;

  function swap (b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }

  Buffer.prototype.swap16 = function swap16 () {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits')
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this
  };

  Buffer.prototype.swap32 = function swap32 () {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits')
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this
  };

  Buffer.prototype.swap64 = function swap64 () {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits')
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this
  };

  Buffer.prototype.toString = function toString () {
    var length = this.length | 0;
    if (length === 0) return ''
    if (arguments.length === 0) return utf8Slice(this, 0, length)
    return slowToString.apply(this, arguments)
  };

  Buffer.prototype.equals = function equals (b) {
    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    if (this === b) return true
    return Buffer.compare(this, b) === 0
  };

  Buffer.prototype.inspect = function inspect () {
    var str = '';
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
      if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>'
  };

  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
      throw new TypeError('Argument must be a Buffer')
    }

    if (start === undefined) {
      start = 0;
    }
    if (end === undefined) {
      end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
      thisStart = 0;
    }
    if (thisEnd === undefined) {
      thisEnd = this.length;
    }

    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index')
    }

    if (thisStart >= thisEnd && start >= end) {
      return 0
    }
    if (thisStart >= thisEnd) {
      return -1
    }
    if (start >= end) {
      return 1
    }

    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;

    if (this === target) return 0

    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);

    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);

    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf
  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1

    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset;  // Coerce to Number.
    if (isNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : (buffer.length - 1);
    }

    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
      if (dir) return -1
      else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;
      else return -1
    }

    // Normalize val
    if (typeof val === 'string') {
      val = Buffer.from(val, encoding);
    }

    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    } else if (typeof val === 'number') {
      val = val & 0xFF; // Search for a byte value [0-255]
      if (Buffer.TYPED_ARRAY_SUPPORT &&
          typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
        }
      }
      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    }

    throw new TypeError('val must be string, number or Buffer')
  }

  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;

    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();
      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
          encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }

    function read (buf, i) {
      if (indexSize === 1) {
        return buf[i]
      } else {
        return buf.readUInt16BE(i * indexSize)
      }
    }

    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break
          }
        }
        if (found) return i
      }
    }

    return -1
  }

  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1
  };

  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
  };

  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
  };

  function hexWrite (buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }

    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    if (length > strLen / 2) {
      length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (isNaN(parsed)) return i
      buf[offset + i] = parsed;
    }
    return i
  }

  function utf8Write (buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
  }

  function asciiWrite (buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length)
  }

  function latin1Write (buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length)
  }

  function base64Write (buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length)
  }

  function ucs2Write (buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
  }

  Buffer.prototype.write = function write (string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset | 0;
      if (isFinite(length)) {
        length = length | 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else {
      throw new Error(
        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
      )
    }

    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;

    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds')
    }

    if (!encoding) encoding = 'utf8';

    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length)

        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length)

        case 'ascii':
          return asciiWrite(this, string, offset, length)

        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length)

        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };

  Buffer.prototype.toJSON = function toJSON () {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    }
  };

  function base64Slice (buf, start, end) {
    if (start === 0 && end === buf.length) {
      return fromByteArray(buf)
    } else {
      return fromByteArray(buf.slice(start, end))
    }
  }

  function utf8Slice (buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];

    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = (firstByte > 0xEF) ? 4
        : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
        : 1;

      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;

        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }
            break
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }
        }
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }

      res.push(codePoint);
      i += bytesPerSequence;
    }

    return decodeCodePointsArray(res)
  }

  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety
  var MAX_ARGUMENTS_LENGTH = 0x1000;

  function decodeCodePointsArray (codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    }

    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(
        String,
        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
      );
    }
    return res
  }

  function asciiSlice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret
  }

  function latin1Slice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret
  }

  function hexSlice (buf, start, end) {
    var len = buf.length;

    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;

    var out = '';
    for (var i = start; i < end; ++i) {
      out += toHex(buf[i]);
    }
    return out
  }

  function utf16leSlice (buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res
  }

  Buffer.prototype.slice = function slice (start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;

    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }

    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }

    if (end < start) end = start;

    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      newBuf = this.subarray(start, end);
      newBuf.__proto__ = Buffer.prototype;
    } else {
      var sliceLen = end - start;
      newBuf = new Buffer(sliceLen, undefined);
      for (var i = 0; i < sliceLen; ++i) {
        newBuf[i] = this[i + start];
      }
    }

    return newBuf
  };

  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */
  function checkOffset (offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
  }

  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    return val
  };

  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }

    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }

    return val
  };

  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset]
  };

  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | (this[offset + 1] << 8)
  };

  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return (this[offset] << 8) | this[offset + 1]
  };

  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return ((this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16)) +
        (this[offset + 3] * 0x1000000)
  };

  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] * 0x1000000) +
      ((this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      this[offset + 3])
  };

  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return (this[offset])
    return ((0xff - this[offset] + 1) * -1)
  };

  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | (this[offset + 1] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | (this[offset] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16) |
      (this[offset + 3] << 24)
  };

  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] << 24) |
      (this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      (this[offset + 3])
  };

  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4)
  };

  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4)
  };

  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8)
  };

  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8)
  };

  function checkInt (buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
  }

  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = (value & 0xff);
    return offset + 1
  };

  function objectWriteUInt16 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
        (littleEndian ? i : 1 - i) * 8;
    }
  }

  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  function objectWriteUInt32 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    }
  }

  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset + 3] = (value >>> 24);
      this[offset + 2] = (value >>> 16);
      this[offset + 1] = (value >>> 8);
      this[offset] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = (value & 0xff);
    return offset + 1
  };

  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
      this[offset + 2] = (value >>> 16);
      this[offset + 3] = (value >>> 24);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  function checkIEEE754 (buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    if (offset < 0) throw new RangeError('Index out of range')
  }

  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4
  }

  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert)
  };

  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8
  }

  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert)
  };

  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;

    // Copy 0 bytes; we're done
    if (end === start) return 0
    if (target.length === 0 || this.length === 0) return 0

    // Fatal error conditions
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds')
    }
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    if (end < 0) throw new RangeError('sourceEnd out of bounds')

    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }

    var len = end - start;
    var i;

    if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
      // ascending copy from start
      for (i = 0; i < len; ++i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(
        target,
        this.subarray(start, start + len),
        targetStart
      );
    }

    return len
  };

  // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])
  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0);
        if (code < 256) {
          val = code;
        }
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string')
      }
      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding)
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    }

    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index')
    }

    if (end <= start) {
      return this
    }

    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;

    if (!val) val = 0;

    var i;
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = internalIsBuffer(val)
        ? val
        : utf8ToBytes(new Buffer(val, encoding).toString());
      var len = bytes.length;
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }

    return this
  };

  // HELPER FUNCTIONS
  // ================

  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

  function base64clean (str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return ''
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
      str = str + '=';
    }
    return str
  }

  function stringtrim (str) {
    if (str.trim) return str.trim()
    return str.replace(/^\s+|\s+$/g, '')
  }

  function toHex (n) {
    if (n < 16) return '0' + n.toString(16)
    return n.toString(16)
  }

  function utf8ToBytes (string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];

    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);

      // is surrogate component
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          }

          // valid lead
          leadSurrogate = codePoint;

          continue
        }

        // 2 leads in a row
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue
        }

        // valid surrogate pair
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }

      leadSurrogate = null;

      // encode utf8
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break
        bytes.push(
          codePoint >> 0x6 | 0xC0,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break
        bytes.push(
          codePoint >> 0xC | 0xE0,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break
        bytes.push(
          codePoint >> 0x12 | 0xF0,
          codePoint >> 0xC & 0x3F | 0x80,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else {
        throw new Error('Invalid code point')
      }
    }

    return bytes
  }

  function asciiToBytes (str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray
  }

  function utf16leToBytes (str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break

      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }

    return byteArray
  }


  function base64ToBytes (str) {
    return toByteArray(base64clean(str))
  }

  function blitBuffer (src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if ((i + offset >= dst.length) || (i >= src.length)) break
      dst[i + offset] = src[i];
    }
    return i
  }

  function isnan (val) {
    return val !== val // eslint-disable-line no-self-compare
  }


  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
  }

  function isFastBuffer (obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
  }

  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer (obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
  }

  var _polyfillNode_buffer = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Buffer: Buffer,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer,
    kMaxLength: _kMaxLength
  });

  var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_buffer);

  bn.exports;

  (function (module) {
  	(function (module, exports) {

  	  // Utils
  	  function assert (val, msg) {
  	    if (!val) throw new Error(msg || 'Assertion failed');
  	  }

  	  // Could use `inherits` module, but don't want to move from single file
  	  // architecture yet.
  	  function inherits (ctor, superCtor) {
  	    ctor.super_ = superCtor;
  	    var TempCtor = function () {};
  	    TempCtor.prototype = superCtor.prototype;
  	    ctor.prototype = new TempCtor();
  	    ctor.prototype.constructor = ctor;
  	  }

  	  // BN

  	  function BN (number, base, endian) {
  	    if (BN.isBN(number)) {
  	      return number;
  	    }

  	    this.negative = 0;
  	    this.words = null;
  	    this.length = 0;

  	    // Reduction context
  	    this.red = null;

  	    if (number !== null) {
  	      if (base === 'le' || base === 'be') {
  	        endian = base;
  	        base = 10;
  	      }

  	      this._init(number || 0, base || 10, endian || 'be');
  	    }
  	  }
  	  if (typeof module === 'object') {
  	    module.exports = BN;
  	  } else {
  	    exports.BN = BN;
  	  }

  	  BN.BN = BN;
  	  BN.wordSize = 26;

  	  var Buffer;
  	  try {
  	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
  	      Buffer = window.Buffer;
  	    } else {
  	      Buffer = require$$0.Buffer;
  	    }
  	  } catch (e) {
  	  }

  	  BN.isBN = function isBN (num) {
  	    if (num instanceof BN) {
  	      return true;
  	    }

  	    return num !== null && typeof num === 'object' &&
  	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  	  };

  	  BN.max = function max (left, right) {
  	    if (left.cmp(right) > 0) return left;
  	    return right;
  	  };

  	  BN.min = function min (left, right) {
  	    if (left.cmp(right) < 0) return left;
  	    return right;
  	  };

  	  BN.prototype._init = function init (number, base, endian) {
  	    if (typeof number === 'number') {
  	      return this._initNumber(number, base, endian);
  	    }

  	    if (typeof number === 'object') {
  	      return this._initArray(number, base, endian);
  	    }

  	    if (base === 'hex') {
  	      base = 16;
  	    }
  	    assert(base === (base | 0) && base >= 2 && base <= 36);

  	    number = number.toString().replace(/\s+/g, '');
  	    var start = 0;
  	    if (number[0] === '-') {
  	      start++;
  	      this.negative = 1;
  	    }

  	    if (start < number.length) {
  	      if (base === 16) {
  	        this._parseHex(number, start, endian);
  	      } else {
  	        this._parseBase(number, base, start);
  	        if (endian === 'le') {
  	          this._initArray(this.toArray(), base, endian);
  	        }
  	      }
  	    }
  	  };

  	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
  	    if (number < 0) {
  	      this.negative = 1;
  	      number = -number;
  	    }
  	    if (number < 0x4000000) {
  	      this.words = [ number & 0x3ffffff ];
  	      this.length = 1;
  	    } else if (number < 0x10000000000000) {
  	      this.words = [
  	        number & 0x3ffffff,
  	        (number / 0x4000000) & 0x3ffffff
  	      ];
  	      this.length = 2;
  	    } else {
  	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
  	      this.words = [
  	        number & 0x3ffffff,
  	        (number / 0x4000000) & 0x3ffffff,
  	        1
  	      ];
  	      this.length = 3;
  	    }

  	    if (endian !== 'le') return;

  	    // Reverse the bytes
  	    this._initArray(this.toArray(), base, endian);
  	  };

  	  BN.prototype._initArray = function _initArray (number, base, endian) {
  	    // Perhaps a Uint8Array
  	    assert(typeof number.length === 'number');
  	    if (number.length <= 0) {
  	      this.words = [ 0 ];
  	      this.length = 1;
  	      return this;
  	    }

  	    this.length = Math.ceil(number.length / 3);
  	    this.words = new Array(this.length);
  	    for (var i = 0; i < this.length; i++) {
  	      this.words[i] = 0;
  	    }

  	    var j, w;
  	    var off = 0;
  	    if (endian === 'be') {
  	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
  	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
  	        this.words[j] |= (w << off) & 0x3ffffff;
  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
  	        off += 24;
  	        if (off >= 26) {
  	          off -= 26;
  	          j++;
  	        }
  	      }
  	    } else if (endian === 'le') {
  	      for (i = 0, j = 0; i < number.length; i += 3) {
  	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
  	        this.words[j] |= (w << off) & 0x3ffffff;
  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
  	        off += 24;
  	        if (off >= 26) {
  	          off -= 26;
  	          j++;
  	        }
  	      }
  	    }
  	    return this.strip();
  	  };

  	  function parseHex4Bits (string, index) {
  	    var c = string.charCodeAt(index);
  	    // 'A' - 'F'
  	    if (c >= 65 && c <= 70) {
  	      return c - 55;
  	    // 'a' - 'f'
  	    } else if (c >= 97 && c <= 102) {
  	      return c - 87;
  	    // '0' - '9'
  	    } else {
  	      return (c - 48) & 0xf;
  	    }
  	  }

  	  function parseHexByte (string, lowerBound, index) {
  	    var r = parseHex4Bits(string, index);
  	    if (index - 1 >= lowerBound) {
  	      r |= parseHex4Bits(string, index - 1) << 4;
  	    }
  	    return r;
  	  }

  	  BN.prototype._parseHex = function _parseHex (number, start, endian) {
  	    // Create possibly bigger array to ensure that it fits the number
  	    this.length = Math.ceil((number.length - start) / 6);
  	    this.words = new Array(this.length);
  	    for (var i = 0; i < this.length; i++) {
  	      this.words[i] = 0;
  	    }

  	    // 24-bits chunks
  	    var off = 0;
  	    var j = 0;

  	    var w;
  	    if (endian === 'be') {
  	      for (i = number.length - 1; i >= start; i -= 2) {
  	        w = parseHexByte(number, start, i) << off;
  	        this.words[j] |= w & 0x3ffffff;
  	        if (off >= 18) {
  	          off -= 18;
  	          j += 1;
  	          this.words[j] |= w >>> 26;
  	        } else {
  	          off += 8;
  	        }
  	      }
  	    } else {
  	      var parseLength = number.length - start;
  	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
  	        w = parseHexByte(number, start, i) << off;
  	        this.words[j] |= w & 0x3ffffff;
  	        if (off >= 18) {
  	          off -= 18;
  	          j += 1;
  	          this.words[j] |= w >>> 26;
  	        } else {
  	          off += 8;
  	        }
  	      }
  	    }

  	    this.strip();
  	  };

  	  function parseBase (str, start, end, mul) {
  	    var r = 0;
  	    var len = Math.min(str.length, end);
  	    for (var i = start; i < len; i++) {
  	      var c = str.charCodeAt(i) - 48;

  	      r *= mul;

  	      // 'a'
  	      if (c >= 49) {
  	        r += c - 49 + 0xa;

  	      // 'A'
  	      } else if (c >= 17) {
  	        r += c - 17 + 0xa;

  	      // '0' - '9'
  	      } else {
  	        r += c;
  	      }
  	    }
  	    return r;
  	  }

  	  BN.prototype._parseBase = function _parseBase (number, base, start) {
  	    // Initialize as zero
  	    this.words = [ 0 ];
  	    this.length = 1;

  	    // Find length of limb in base
  	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
  	      limbLen++;
  	    }
  	    limbLen--;
  	    limbPow = (limbPow / base) | 0;

  	    var total = number.length - start;
  	    var mod = total % limbLen;
  	    var end = Math.min(total, total - mod) + start;

  	    var word = 0;
  	    for (var i = start; i < end; i += limbLen) {
  	      word = parseBase(number, i, i + limbLen, base);

  	      this.imuln(limbPow);
  	      if (this.words[0] + word < 0x4000000) {
  	        this.words[0] += word;
  	      } else {
  	        this._iaddn(word);
  	      }
  	    }

  	    if (mod !== 0) {
  	      var pow = 1;
  	      word = parseBase(number, i, number.length, base);

  	      for (i = 0; i < mod; i++) {
  	        pow *= base;
  	      }

  	      this.imuln(pow);
  	      if (this.words[0] + word < 0x4000000) {
  	        this.words[0] += word;
  	      } else {
  	        this._iaddn(word);
  	      }
  	    }

  	    this.strip();
  	  };

  	  BN.prototype.copy = function copy (dest) {
  	    dest.words = new Array(this.length);
  	    for (var i = 0; i < this.length; i++) {
  	      dest.words[i] = this.words[i];
  	    }
  	    dest.length = this.length;
  	    dest.negative = this.negative;
  	    dest.red = this.red;
  	  };

  	  BN.prototype.clone = function clone () {
  	    var r = new BN(null);
  	    this.copy(r);
  	    return r;
  	  };

  	  BN.prototype._expand = function _expand (size) {
  	    while (this.length < size) {
  	      this.words[this.length++] = 0;
  	    }
  	    return this;
  	  };

  	  // Remove leading `0` from `this`
  	  BN.prototype.strip = function strip () {
  	    while (this.length > 1 && this.words[this.length - 1] === 0) {
  	      this.length--;
  	    }
  	    return this._normSign();
  	  };

  	  BN.prototype._normSign = function _normSign () {
  	    // -0 = 0
  	    if (this.length === 1 && this.words[0] === 0) {
  	      this.negative = 0;
  	    }
  	    return this;
  	  };

  	  BN.prototype.inspect = function inspect () {
  	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  	  };

  	  /*

  	  var zeros = [];
  	  var groupSizes = [];
  	  var groupBases = [];

  	  var s = '';
  	  var i = -1;
  	  while (++i < BN.wordSize) {
  	    zeros[i] = s;
  	    s += '0';
  	  }
  	  groupSizes[0] = 0;
  	  groupSizes[1] = 0;
  	  groupBases[0] = 0;
  	  groupBases[1] = 0;
  	  var base = 2 - 1;
  	  while (++base < 36 + 1) {
  	    var groupSize = 0;
  	    var groupBase = 1;
  	    while (groupBase < (1 << BN.wordSize) / base) {
  	      groupBase *= base;
  	      groupSize += 1;
  	    }
  	    groupSizes[base] = groupSize;
  	    groupBases[base] = groupBase;
  	  }

  	  */

  	  var zeros = [
  	    '',
  	    '0',
  	    '00',
  	    '000',
  	    '0000',
  	    '00000',
  	    '000000',
  	    '0000000',
  	    '00000000',
  	    '000000000',
  	    '0000000000',
  	    '00000000000',
  	    '000000000000',
  	    '0000000000000',
  	    '00000000000000',
  	    '000000000000000',
  	    '0000000000000000',
  	    '00000000000000000',
  	    '000000000000000000',
  	    '0000000000000000000',
  	    '00000000000000000000',
  	    '000000000000000000000',
  	    '0000000000000000000000',
  	    '00000000000000000000000',
  	    '000000000000000000000000',
  	    '0000000000000000000000000'
  	  ];

  	  var groupSizes = [
  	    0, 0,
  	    25, 16, 12, 11, 10, 9, 8,
  	    8, 7, 7, 7, 7, 6, 6,
  	    6, 6, 6, 6, 6, 5, 5,
  	    5, 5, 5, 5, 5, 5, 5,
  	    5, 5, 5, 5, 5, 5, 5
  	  ];

  	  var groupBases = [
  	    0, 0,
  	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
  	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
  	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
  	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
  	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  	  ];

  	  BN.prototype.toString = function toString (base, padding) {
  	    base = base || 10;
  	    padding = padding | 0 || 1;

  	    var out;
  	    if (base === 16 || base === 'hex') {
  	      out = '';
  	      var off = 0;
  	      var carry = 0;
  	      for (var i = 0; i < this.length; i++) {
  	        var w = this.words[i];
  	        var word = (((w << off) | carry) & 0xffffff).toString(16);
  	        carry = (w >>> (24 - off)) & 0xffffff;
  	        if (carry !== 0 || i !== this.length - 1) {
  	          out = zeros[6 - word.length] + word + out;
  	        } else {
  	          out = word + out;
  	        }
  	        off += 2;
  	        if (off >= 26) {
  	          off -= 26;
  	          i--;
  	        }
  	      }
  	      if (carry !== 0) {
  	        out = carry.toString(16) + out;
  	      }
  	      while (out.length % padding !== 0) {
  	        out = '0' + out;
  	      }
  	      if (this.negative !== 0) {
  	        out = '-' + out;
  	      }
  	      return out;
  	    }

  	    if (base === (base | 0) && base >= 2 && base <= 36) {
  	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
  	      var groupSize = groupSizes[base];
  	      // var groupBase = Math.pow(base, groupSize);
  	      var groupBase = groupBases[base];
  	      out = '';
  	      var c = this.clone();
  	      c.negative = 0;
  	      while (!c.isZero()) {
  	        var r = c.modn(groupBase).toString(base);
  	        c = c.idivn(groupBase);

  	        if (!c.isZero()) {
  	          out = zeros[groupSize - r.length] + r + out;
  	        } else {
  	          out = r + out;
  	        }
  	      }
  	      if (this.isZero()) {
  	        out = '0' + out;
  	      }
  	      while (out.length % padding !== 0) {
  	        out = '0' + out;
  	      }
  	      if (this.negative !== 0) {
  	        out = '-' + out;
  	      }
  	      return out;
  	    }

  	    assert(false, 'Base should be between 2 and 36');
  	  };

  	  BN.prototype.toNumber = function toNumber () {
  	    var ret = this.words[0];
  	    if (this.length === 2) {
  	      ret += this.words[1] * 0x4000000;
  	    } else if (this.length === 3 && this.words[2] === 0x01) {
  	      // NOTE: at this stage it is known that the top bit is set
  	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
  	    } else if (this.length > 2) {
  	      assert(false, 'Number can only safely store up to 53 bits');
  	    }
  	    return (this.negative !== 0) ? -ret : ret;
  	  };

  	  BN.prototype.toJSON = function toJSON () {
  	    return this.toString(16);
  	  };

  	  BN.prototype.toBuffer = function toBuffer (endian, length) {
  	    assert(typeof Buffer !== 'undefined');
  	    return this.toArrayLike(Buffer, endian, length);
  	  };

  	  BN.prototype.toArray = function toArray (endian, length) {
  	    return this.toArrayLike(Array, endian, length);
  	  };

  	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
  	    var byteLength = this.byteLength();
  	    var reqLength = length || Math.max(1, byteLength);
  	    assert(byteLength <= reqLength, 'byte array longer than desired length');
  	    assert(reqLength > 0, 'Requested array length <= 0');

  	    this.strip();
  	    var littleEndian = endian === 'le';
  	    var res = new ArrayType(reqLength);

  	    var b, i;
  	    var q = this.clone();
  	    if (!littleEndian) {
  	      // Assume big-endian
  	      for (i = 0; i < reqLength - byteLength; i++) {
  	        res[i] = 0;
  	      }

  	      for (i = 0; !q.isZero(); i++) {
  	        b = q.andln(0xff);
  	        q.iushrn(8);

  	        res[reqLength - i - 1] = b;
  	      }
  	    } else {
  	      for (i = 0; !q.isZero(); i++) {
  	        b = q.andln(0xff);
  	        q.iushrn(8);

  	        res[i] = b;
  	      }

  	      for (; i < reqLength; i++) {
  	        res[i] = 0;
  	      }
  	    }

  	    return res;
  	  };

  	  if (Math.clz32) {
  	    BN.prototype._countBits = function _countBits (w) {
  	      return 32 - Math.clz32(w);
  	    };
  	  } else {
  	    BN.prototype._countBits = function _countBits (w) {
  	      var t = w;
  	      var r = 0;
  	      if (t >= 0x1000) {
  	        r += 13;
  	        t >>>= 13;
  	      }
  	      if (t >= 0x40) {
  	        r += 7;
  	        t >>>= 7;
  	      }
  	      if (t >= 0x8) {
  	        r += 4;
  	        t >>>= 4;
  	      }
  	      if (t >= 0x02) {
  	        r += 2;
  	        t >>>= 2;
  	      }
  	      return r + t;
  	    };
  	  }

  	  BN.prototype._zeroBits = function _zeroBits (w) {
  	    // Short-cut
  	    if (w === 0) return 26;

  	    var t = w;
  	    var r = 0;
  	    if ((t & 0x1fff) === 0) {
  	      r += 13;
  	      t >>>= 13;
  	    }
  	    if ((t & 0x7f) === 0) {
  	      r += 7;
  	      t >>>= 7;
  	    }
  	    if ((t & 0xf) === 0) {
  	      r += 4;
  	      t >>>= 4;
  	    }
  	    if ((t & 0x3) === 0) {
  	      r += 2;
  	      t >>>= 2;
  	    }
  	    if ((t & 0x1) === 0) {
  	      r++;
  	    }
  	    return r;
  	  };

  	  // Return number of used bits in a BN
  	  BN.prototype.bitLength = function bitLength () {
  	    var w = this.words[this.length - 1];
  	    var hi = this._countBits(w);
  	    return (this.length - 1) * 26 + hi;
  	  };

  	  function toBitArray (num) {
  	    var w = new Array(num.bitLength());

  	    for (var bit = 0; bit < w.length; bit++) {
  	      var off = (bit / 26) | 0;
  	      var wbit = bit % 26;

  	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
  	    }

  	    return w;
  	  }

  	  // Number of trailing zero bits
  	  BN.prototype.zeroBits = function zeroBits () {
  	    if (this.isZero()) return 0;

  	    var r = 0;
  	    for (var i = 0; i < this.length; i++) {
  	      var b = this._zeroBits(this.words[i]);
  	      r += b;
  	      if (b !== 26) break;
  	    }
  	    return r;
  	  };

  	  BN.prototype.byteLength = function byteLength () {
  	    return Math.ceil(this.bitLength() / 8);
  	  };

  	  BN.prototype.toTwos = function toTwos (width) {
  	    if (this.negative !== 0) {
  	      return this.abs().inotn(width).iaddn(1);
  	    }
  	    return this.clone();
  	  };

  	  BN.prototype.fromTwos = function fromTwos (width) {
  	    if (this.testn(width - 1)) {
  	      return this.notn(width).iaddn(1).ineg();
  	    }
  	    return this.clone();
  	  };

  	  BN.prototype.isNeg = function isNeg () {
  	    return this.negative !== 0;
  	  };

  	  // Return negative clone of `this`
  	  BN.prototype.neg = function neg () {
  	    return this.clone().ineg();
  	  };

  	  BN.prototype.ineg = function ineg () {
  	    if (!this.isZero()) {
  	      this.negative ^= 1;
  	    }

  	    return this;
  	  };

  	  // Or `num` with `this` in-place
  	  BN.prototype.iuor = function iuor (num) {
  	    while (this.length < num.length) {
  	      this.words[this.length++] = 0;
  	    }

  	    for (var i = 0; i < num.length; i++) {
  	      this.words[i] = this.words[i] | num.words[i];
  	    }

  	    return this.strip();
  	  };

  	  BN.prototype.ior = function ior (num) {
  	    assert((this.negative | num.negative) === 0);
  	    return this.iuor(num);
  	  };

  	  // Or `num` with `this`
  	  BN.prototype.or = function or (num) {
  	    if (this.length > num.length) return this.clone().ior(num);
  	    return num.clone().ior(this);
  	  };

  	  BN.prototype.uor = function uor (num) {
  	    if (this.length > num.length) return this.clone().iuor(num);
  	    return num.clone().iuor(this);
  	  };

  	  // And `num` with `this` in-place
  	  BN.prototype.iuand = function iuand (num) {
  	    // b = min-length(num, this)
  	    var b;
  	    if (this.length > num.length) {
  	      b = num;
  	    } else {
  	      b = this;
  	    }

  	    for (var i = 0; i < b.length; i++) {
  	      this.words[i] = this.words[i] & num.words[i];
  	    }

  	    this.length = b.length;

  	    return this.strip();
  	  };

  	  BN.prototype.iand = function iand (num) {
  	    assert((this.negative | num.negative) === 0);
  	    return this.iuand(num);
  	  };

  	  // And `num` with `this`
  	  BN.prototype.and = function and (num) {
  	    if (this.length > num.length) return this.clone().iand(num);
  	    return num.clone().iand(this);
  	  };

  	  BN.prototype.uand = function uand (num) {
  	    if (this.length > num.length) return this.clone().iuand(num);
  	    return num.clone().iuand(this);
  	  };

  	  // Xor `num` with `this` in-place
  	  BN.prototype.iuxor = function iuxor (num) {
  	    // a.length > b.length
  	    var a;
  	    var b;
  	    if (this.length > num.length) {
  	      a = this;
  	      b = num;
  	    } else {
  	      a = num;
  	      b = this;
  	    }

  	    for (var i = 0; i < b.length; i++) {
  	      this.words[i] = a.words[i] ^ b.words[i];
  	    }

  	    if (this !== a) {
  	      for (; i < a.length; i++) {
  	        this.words[i] = a.words[i];
  	      }
  	    }

  	    this.length = a.length;

  	    return this.strip();
  	  };

  	  BN.prototype.ixor = function ixor (num) {
  	    assert((this.negative | num.negative) === 0);
  	    return this.iuxor(num);
  	  };

  	  // Xor `num` with `this`
  	  BN.prototype.xor = function xor (num) {
  	    if (this.length > num.length) return this.clone().ixor(num);
  	    return num.clone().ixor(this);
  	  };

  	  BN.prototype.uxor = function uxor (num) {
  	    if (this.length > num.length) return this.clone().iuxor(num);
  	    return num.clone().iuxor(this);
  	  };

  	  // Not ``this`` with ``width`` bitwidth
  	  BN.prototype.inotn = function inotn (width) {
  	    assert(typeof width === 'number' && width >= 0);

  	    var bytesNeeded = Math.ceil(width / 26) | 0;
  	    var bitsLeft = width % 26;

  	    // Extend the buffer with leading zeroes
  	    this._expand(bytesNeeded);

  	    if (bitsLeft > 0) {
  	      bytesNeeded--;
  	    }

  	    // Handle complete words
  	    for (var i = 0; i < bytesNeeded; i++) {
  	      this.words[i] = ~this.words[i] & 0x3ffffff;
  	    }

  	    // Handle the residue
  	    if (bitsLeft > 0) {
  	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
  	    }

  	    // And remove leading zeroes
  	    return this.strip();
  	  };

  	  BN.prototype.notn = function notn (width) {
  	    return this.clone().inotn(width);
  	  };

  	  // Set `bit` of `this`
  	  BN.prototype.setn = function setn (bit, val) {
  	    assert(typeof bit === 'number' && bit >= 0);

  	    var off = (bit / 26) | 0;
  	    var wbit = bit % 26;

  	    this._expand(off + 1);

  	    if (val) {
  	      this.words[off] = this.words[off] | (1 << wbit);
  	    } else {
  	      this.words[off] = this.words[off] & ~(1 << wbit);
  	    }

  	    return this.strip();
  	  };

  	  // Add `num` to `this` in-place
  	  BN.prototype.iadd = function iadd (num) {
  	    var r;

  	    // negative + positive
  	    if (this.negative !== 0 && num.negative === 0) {
  	      this.negative = 0;
  	      r = this.isub(num);
  	      this.negative ^= 1;
  	      return this._normSign();

  	    // positive + negative
  	    } else if (this.negative === 0 && num.negative !== 0) {
  	      num.negative = 0;
  	      r = this.isub(num);
  	      num.negative = 1;
  	      return r._normSign();
  	    }

  	    // a.length > b.length
  	    var a, b;
  	    if (this.length > num.length) {
  	      a = this;
  	      b = num;
  	    } else {
  	      a = num;
  	      b = this;
  	    }

  	    var carry = 0;
  	    for (var i = 0; i < b.length; i++) {
  	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
  	      this.words[i] = r & 0x3ffffff;
  	      carry = r >>> 26;
  	    }
  	    for (; carry !== 0 && i < a.length; i++) {
  	      r = (a.words[i] | 0) + carry;
  	      this.words[i] = r & 0x3ffffff;
  	      carry = r >>> 26;
  	    }

  	    this.length = a.length;
  	    if (carry !== 0) {
  	      this.words[this.length] = carry;
  	      this.length++;
  	    // Copy the rest of the words
  	    } else if (a !== this) {
  	      for (; i < a.length; i++) {
  	        this.words[i] = a.words[i];
  	      }
  	    }

  	    return this;
  	  };

  	  // Add `num` to `this`
  	  BN.prototype.add = function add (num) {
  	    var res;
  	    if (num.negative !== 0 && this.negative === 0) {
  	      num.negative = 0;
  	      res = this.sub(num);
  	      num.negative ^= 1;
  	      return res;
  	    } else if (num.negative === 0 && this.negative !== 0) {
  	      this.negative = 0;
  	      res = num.sub(this);
  	      this.negative = 1;
  	      return res;
  	    }

  	    if (this.length > num.length) return this.clone().iadd(num);

  	    return num.clone().iadd(this);
  	  };

  	  // Subtract `num` from `this` in-place
  	  BN.prototype.isub = function isub (num) {
  	    // this - (-num) = this + num
  	    if (num.negative !== 0) {
  	      num.negative = 0;
  	      var r = this.iadd(num);
  	      num.negative = 1;
  	      return r._normSign();

  	    // -this - num = -(this + num)
  	    } else if (this.negative !== 0) {
  	      this.negative = 0;
  	      this.iadd(num);
  	      this.negative = 1;
  	      return this._normSign();
  	    }

  	    // At this point both numbers are positive
  	    var cmp = this.cmp(num);

  	    // Optimization - zeroify
  	    if (cmp === 0) {
  	      this.negative = 0;
  	      this.length = 1;
  	      this.words[0] = 0;
  	      return this;
  	    }

  	    // a > b
  	    var a, b;
  	    if (cmp > 0) {
  	      a = this;
  	      b = num;
  	    } else {
  	      a = num;
  	      b = this;
  	    }

  	    var carry = 0;
  	    for (var i = 0; i < b.length; i++) {
  	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
  	      carry = r >> 26;
  	      this.words[i] = r & 0x3ffffff;
  	    }
  	    for (; carry !== 0 && i < a.length; i++) {
  	      r = (a.words[i] | 0) + carry;
  	      carry = r >> 26;
  	      this.words[i] = r & 0x3ffffff;
  	    }

  	    // Copy rest of the words
  	    if (carry === 0 && i < a.length && a !== this) {
  	      for (; i < a.length; i++) {
  	        this.words[i] = a.words[i];
  	      }
  	    }

  	    this.length = Math.max(this.length, i);

  	    if (a !== this) {
  	      this.negative = 1;
  	    }

  	    return this.strip();
  	  };

  	  // Subtract `num` from `this`
  	  BN.prototype.sub = function sub (num) {
  	    return this.clone().isub(num);
  	  };

  	  function smallMulTo (self, num, out) {
  	    out.negative = num.negative ^ self.negative;
  	    var len = (self.length + num.length) | 0;
  	    out.length = len;
  	    len = (len - 1) | 0;

  	    // Peel one iteration (compiler can't do it, because of code complexity)
  	    var a = self.words[0] | 0;
  	    var b = num.words[0] | 0;
  	    var r = a * b;

  	    var lo = r & 0x3ffffff;
  	    var carry = (r / 0x4000000) | 0;
  	    out.words[0] = lo;

  	    for (var k = 1; k < len; k++) {
  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
  	      // note that ncarry could be >= 0x3ffffff
  	      var ncarry = carry >>> 26;
  	      var rword = carry & 0x3ffffff;
  	      var maxJ = Math.min(k, num.length - 1);
  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
  	        var i = (k - j) | 0;
  	        a = self.words[i] | 0;
  	        b = num.words[j] | 0;
  	        r = a * b + rword;
  	        ncarry += (r / 0x4000000) | 0;
  	        rword = r & 0x3ffffff;
  	      }
  	      out.words[k] = rword | 0;
  	      carry = ncarry | 0;
  	    }
  	    if (carry !== 0) {
  	      out.words[k] = carry | 0;
  	    } else {
  	      out.length--;
  	    }

  	    return out.strip();
  	  }

  	  // TODO(indutny): it may be reasonable to omit it for users who don't need
  	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  	  // multiplication (like elliptic secp256k1).
  	  var comb10MulTo = function comb10MulTo (self, num, out) {
  	    var a = self.words;
  	    var b = num.words;
  	    var o = out.words;
  	    var c = 0;
  	    var lo;
  	    var mid;
  	    var hi;
  	    var a0 = a[0] | 0;
  	    var al0 = a0 & 0x1fff;
  	    var ah0 = a0 >>> 13;
  	    var a1 = a[1] | 0;
  	    var al1 = a1 & 0x1fff;
  	    var ah1 = a1 >>> 13;
  	    var a2 = a[2] | 0;
  	    var al2 = a2 & 0x1fff;
  	    var ah2 = a2 >>> 13;
  	    var a3 = a[3] | 0;
  	    var al3 = a3 & 0x1fff;
  	    var ah3 = a3 >>> 13;
  	    var a4 = a[4] | 0;
  	    var al4 = a4 & 0x1fff;
  	    var ah4 = a4 >>> 13;
  	    var a5 = a[5] | 0;
  	    var al5 = a5 & 0x1fff;
  	    var ah5 = a5 >>> 13;
  	    var a6 = a[6] | 0;
  	    var al6 = a6 & 0x1fff;
  	    var ah6 = a6 >>> 13;
  	    var a7 = a[7] | 0;
  	    var al7 = a7 & 0x1fff;
  	    var ah7 = a7 >>> 13;
  	    var a8 = a[8] | 0;
  	    var al8 = a8 & 0x1fff;
  	    var ah8 = a8 >>> 13;
  	    var a9 = a[9] | 0;
  	    var al9 = a9 & 0x1fff;
  	    var ah9 = a9 >>> 13;
  	    var b0 = b[0] | 0;
  	    var bl0 = b0 & 0x1fff;
  	    var bh0 = b0 >>> 13;
  	    var b1 = b[1] | 0;
  	    var bl1 = b1 & 0x1fff;
  	    var bh1 = b1 >>> 13;
  	    var b2 = b[2] | 0;
  	    var bl2 = b2 & 0x1fff;
  	    var bh2 = b2 >>> 13;
  	    var b3 = b[3] | 0;
  	    var bl3 = b3 & 0x1fff;
  	    var bh3 = b3 >>> 13;
  	    var b4 = b[4] | 0;
  	    var bl4 = b4 & 0x1fff;
  	    var bh4 = b4 >>> 13;
  	    var b5 = b[5] | 0;
  	    var bl5 = b5 & 0x1fff;
  	    var bh5 = b5 >>> 13;
  	    var b6 = b[6] | 0;
  	    var bl6 = b6 & 0x1fff;
  	    var bh6 = b6 >>> 13;
  	    var b7 = b[7] | 0;
  	    var bl7 = b7 & 0x1fff;
  	    var bh7 = b7 >>> 13;
  	    var b8 = b[8] | 0;
  	    var bl8 = b8 & 0x1fff;
  	    var bh8 = b8 >>> 13;
  	    var b9 = b[9] | 0;
  	    var bl9 = b9 & 0x1fff;
  	    var bh9 = b9 >>> 13;

  	    out.negative = self.negative ^ num.negative;
  	    out.length = 19;
  	    /* k = 0 */
  	    lo = Math.imul(al0, bl0);
  	    mid = Math.imul(al0, bh0);
  	    mid = (mid + Math.imul(ah0, bl0)) | 0;
  	    hi = Math.imul(ah0, bh0);
  	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
  	    w0 &= 0x3ffffff;
  	    /* k = 1 */
  	    lo = Math.imul(al1, bl0);
  	    mid = Math.imul(al1, bh0);
  	    mid = (mid + Math.imul(ah1, bl0)) | 0;
  	    hi = Math.imul(ah1, bh0);
  	    lo = (lo + Math.imul(al0, bl1)) | 0;
  	    mid = (mid + Math.imul(al0, bh1)) | 0;
  	    mid = (mid + Math.imul(ah0, bl1)) | 0;
  	    hi = (hi + Math.imul(ah0, bh1)) | 0;
  	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
  	    w1 &= 0x3ffffff;
  	    /* k = 2 */
  	    lo = Math.imul(al2, bl0);
  	    mid = Math.imul(al2, bh0);
  	    mid = (mid + Math.imul(ah2, bl0)) | 0;
  	    hi = Math.imul(ah2, bh0);
  	    lo = (lo + Math.imul(al1, bl1)) | 0;
  	    mid = (mid + Math.imul(al1, bh1)) | 0;
  	    mid = (mid + Math.imul(ah1, bl1)) | 0;
  	    hi = (hi + Math.imul(ah1, bh1)) | 0;
  	    lo = (lo + Math.imul(al0, bl2)) | 0;
  	    mid = (mid + Math.imul(al0, bh2)) | 0;
  	    mid = (mid + Math.imul(ah0, bl2)) | 0;
  	    hi = (hi + Math.imul(ah0, bh2)) | 0;
  	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
  	    w2 &= 0x3ffffff;
  	    /* k = 3 */
  	    lo = Math.imul(al3, bl0);
  	    mid = Math.imul(al3, bh0);
  	    mid = (mid + Math.imul(ah3, bl0)) | 0;
  	    hi = Math.imul(ah3, bh0);
  	    lo = (lo + Math.imul(al2, bl1)) | 0;
  	    mid = (mid + Math.imul(al2, bh1)) | 0;
  	    mid = (mid + Math.imul(ah2, bl1)) | 0;
  	    hi = (hi + Math.imul(ah2, bh1)) | 0;
  	    lo = (lo + Math.imul(al1, bl2)) | 0;
  	    mid = (mid + Math.imul(al1, bh2)) | 0;
  	    mid = (mid + Math.imul(ah1, bl2)) | 0;
  	    hi = (hi + Math.imul(ah1, bh2)) | 0;
  	    lo = (lo + Math.imul(al0, bl3)) | 0;
  	    mid = (mid + Math.imul(al0, bh3)) | 0;
  	    mid = (mid + Math.imul(ah0, bl3)) | 0;
  	    hi = (hi + Math.imul(ah0, bh3)) | 0;
  	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
  	    w3 &= 0x3ffffff;
  	    /* k = 4 */
  	    lo = Math.imul(al4, bl0);
  	    mid = Math.imul(al4, bh0);
  	    mid = (mid + Math.imul(ah4, bl0)) | 0;
  	    hi = Math.imul(ah4, bh0);
  	    lo = (lo + Math.imul(al3, bl1)) | 0;
  	    mid = (mid + Math.imul(al3, bh1)) | 0;
  	    mid = (mid + Math.imul(ah3, bl1)) | 0;
  	    hi = (hi + Math.imul(ah3, bh1)) | 0;
  	    lo = (lo + Math.imul(al2, bl2)) | 0;
  	    mid = (mid + Math.imul(al2, bh2)) | 0;
  	    mid = (mid + Math.imul(ah2, bl2)) | 0;
  	    hi = (hi + Math.imul(ah2, bh2)) | 0;
  	    lo = (lo + Math.imul(al1, bl3)) | 0;
  	    mid = (mid + Math.imul(al1, bh3)) | 0;
  	    mid = (mid + Math.imul(ah1, bl3)) | 0;
  	    hi = (hi + Math.imul(ah1, bh3)) | 0;
  	    lo = (lo + Math.imul(al0, bl4)) | 0;
  	    mid = (mid + Math.imul(al0, bh4)) | 0;
  	    mid = (mid + Math.imul(ah0, bl4)) | 0;
  	    hi = (hi + Math.imul(ah0, bh4)) | 0;
  	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
  	    w4 &= 0x3ffffff;
  	    /* k = 5 */
  	    lo = Math.imul(al5, bl0);
  	    mid = Math.imul(al5, bh0);
  	    mid = (mid + Math.imul(ah5, bl0)) | 0;
  	    hi = Math.imul(ah5, bh0);
  	    lo = (lo + Math.imul(al4, bl1)) | 0;
  	    mid = (mid + Math.imul(al4, bh1)) | 0;
  	    mid = (mid + Math.imul(ah4, bl1)) | 0;
  	    hi = (hi + Math.imul(ah4, bh1)) | 0;
  	    lo = (lo + Math.imul(al3, bl2)) | 0;
  	    mid = (mid + Math.imul(al3, bh2)) | 0;
  	    mid = (mid + Math.imul(ah3, bl2)) | 0;
  	    hi = (hi + Math.imul(ah3, bh2)) | 0;
  	    lo = (lo + Math.imul(al2, bl3)) | 0;
  	    mid = (mid + Math.imul(al2, bh3)) | 0;
  	    mid = (mid + Math.imul(ah2, bl3)) | 0;
  	    hi = (hi + Math.imul(ah2, bh3)) | 0;
  	    lo = (lo + Math.imul(al1, bl4)) | 0;
  	    mid = (mid + Math.imul(al1, bh4)) | 0;
  	    mid = (mid + Math.imul(ah1, bl4)) | 0;
  	    hi = (hi + Math.imul(ah1, bh4)) | 0;
  	    lo = (lo + Math.imul(al0, bl5)) | 0;
  	    mid = (mid + Math.imul(al0, bh5)) | 0;
  	    mid = (mid + Math.imul(ah0, bl5)) | 0;
  	    hi = (hi + Math.imul(ah0, bh5)) | 0;
  	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
  	    w5 &= 0x3ffffff;
  	    /* k = 6 */
  	    lo = Math.imul(al6, bl0);
  	    mid = Math.imul(al6, bh0);
  	    mid = (mid + Math.imul(ah6, bl0)) | 0;
  	    hi = Math.imul(ah6, bh0);
  	    lo = (lo + Math.imul(al5, bl1)) | 0;
  	    mid = (mid + Math.imul(al5, bh1)) | 0;
  	    mid = (mid + Math.imul(ah5, bl1)) | 0;
  	    hi = (hi + Math.imul(ah5, bh1)) | 0;
  	    lo = (lo + Math.imul(al4, bl2)) | 0;
  	    mid = (mid + Math.imul(al4, bh2)) | 0;
  	    mid = (mid + Math.imul(ah4, bl2)) | 0;
  	    hi = (hi + Math.imul(ah4, bh2)) | 0;
  	    lo = (lo + Math.imul(al3, bl3)) | 0;
  	    mid = (mid + Math.imul(al3, bh3)) | 0;
  	    mid = (mid + Math.imul(ah3, bl3)) | 0;
  	    hi = (hi + Math.imul(ah3, bh3)) | 0;
  	    lo = (lo + Math.imul(al2, bl4)) | 0;
  	    mid = (mid + Math.imul(al2, bh4)) | 0;
  	    mid = (mid + Math.imul(ah2, bl4)) | 0;
  	    hi = (hi + Math.imul(ah2, bh4)) | 0;
  	    lo = (lo + Math.imul(al1, bl5)) | 0;
  	    mid = (mid + Math.imul(al1, bh5)) | 0;
  	    mid = (mid + Math.imul(ah1, bl5)) | 0;
  	    hi = (hi + Math.imul(ah1, bh5)) | 0;
  	    lo = (lo + Math.imul(al0, bl6)) | 0;
  	    mid = (mid + Math.imul(al0, bh6)) | 0;
  	    mid = (mid + Math.imul(ah0, bl6)) | 0;
  	    hi = (hi + Math.imul(ah0, bh6)) | 0;
  	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
  	    w6 &= 0x3ffffff;
  	    /* k = 7 */
  	    lo = Math.imul(al7, bl0);
  	    mid = Math.imul(al7, bh0);
  	    mid = (mid + Math.imul(ah7, bl0)) | 0;
  	    hi = Math.imul(ah7, bh0);
  	    lo = (lo + Math.imul(al6, bl1)) | 0;
  	    mid = (mid + Math.imul(al6, bh1)) | 0;
  	    mid = (mid + Math.imul(ah6, bl1)) | 0;
  	    hi = (hi + Math.imul(ah6, bh1)) | 0;
  	    lo = (lo + Math.imul(al5, bl2)) | 0;
  	    mid = (mid + Math.imul(al5, bh2)) | 0;
  	    mid = (mid + Math.imul(ah5, bl2)) | 0;
  	    hi = (hi + Math.imul(ah5, bh2)) | 0;
  	    lo = (lo + Math.imul(al4, bl3)) | 0;
  	    mid = (mid + Math.imul(al4, bh3)) | 0;
  	    mid = (mid + Math.imul(ah4, bl3)) | 0;
  	    hi = (hi + Math.imul(ah4, bh3)) | 0;
  	    lo = (lo + Math.imul(al3, bl4)) | 0;
  	    mid = (mid + Math.imul(al3, bh4)) | 0;
  	    mid = (mid + Math.imul(ah3, bl4)) | 0;
  	    hi = (hi + Math.imul(ah3, bh4)) | 0;
  	    lo = (lo + Math.imul(al2, bl5)) | 0;
  	    mid = (mid + Math.imul(al2, bh5)) | 0;
  	    mid = (mid + Math.imul(ah2, bl5)) | 0;
  	    hi = (hi + Math.imul(ah2, bh5)) | 0;
  	    lo = (lo + Math.imul(al1, bl6)) | 0;
  	    mid = (mid + Math.imul(al1, bh6)) | 0;
  	    mid = (mid + Math.imul(ah1, bl6)) | 0;
  	    hi = (hi + Math.imul(ah1, bh6)) | 0;
  	    lo = (lo + Math.imul(al0, bl7)) | 0;
  	    mid = (mid + Math.imul(al0, bh7)) | 0;
  	    mid = (mid + Math.imul(ah0, bl7)) | 0;
  	    hi = (hi + Math.imul(ah0, bh7)) | 0;
  	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
  	    w7 &= 0x3ffffff;
  	    /* k = 8 */
  	    lo = Math.imul(al8, bl0);
  	    mid = Math.imul(al8, bh0);
  	    mid = (mid + Math.imul(ah8, bl0)) | 0;
  	    hi = Math.imul(ah8, bh0);
  	    lo = (lo + Math.imul(al7, bl1)) | 0;
  	    mid = (mid + Math.imul(al7, bh1)) | 0;
  	    mid = (mid + Math.imul(ah7, bl1)) | 0;
  	    hi = (hi + Math.imul(ah7, bh1)) | 0;
  	    lo = (lo + Math.imul(al6, bl2)) | 0;
  	    mid = (mid + Math.imul(al6, bh2)) | 0;
  	    mid = (mid + Math.imul(ah6, bl2)) | 0;
  	    hi = (hi + Math.imul(ah6, bh2)) | 0;
  	    lo = (lo + Math.imul(al5, bl3)) | 0;
  	    mid = (mid + Math.imul(al5, bh3)) | 0;
  	    mid = (mid + Math.imul(ah5, bl3)) | 0;
  	    hi = (hi + Math.imul(ah5, bh3)) | 0;
  	    lo = (lo + Math.imul(al4, bl4)) | 0;
  	    mid = (mid + Math.imul(al4, bh4)) | 0;
  	    mid = (mid + Math.imul(ah4, bl4)) | 0;
  	    hi = (hi + Math.imul(ah4, bh4)) | 0;
  	    lo = (lo + Math.imul(al3, bl5)) | 0;
  	    mid = (mid + Math.imul(al3, bh5)) | 0;
  	    mid = (mid + Math.imul(ah3, bl5)) | 0;
  	    hi = (hi + Math.imul(ah3, bh5)) | 0;
  	    lo = (lo + Math.imul(al2, bl6)) | 0;
  	    mid = (mid + Math.imul(al2, bh6)) | 0;
  	    mid = (mid + Math.imul(ah2, bl6)) | 0;
  	    hi = (hi + Math.imul(ah2, bh6)) | 0;
  	    lo = (lo + Math.imul(al1, bl7)) | 0;
  	    mid = (mid + Math.imul(al1, bh7)) | 0;
  	    mid = (mid + Math.imul(ah1, bl7)) | 0;
  	    hi = (hi + Math.imul(ah1, bh7)) | 0;
  	    lo = (lo + Math.imul(al0, bl8)) | 0;
  	    mid = (mid + Math.imul(al0, bh8)) | 0;
  	    mid = (mid + Math.imul(ah0, bl8)) | 0;
  	    hi = (hi + Math.imul(ah0, bh8)) | 0;
  	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
  	    w8 &= 0x3ffffff;
  	    /* k = 9 */
  	    lo = Math.imul(al9, bl0);
  	    mid = Math.imul(al9, bh0);
  	    mid = (mid + Math.imul(ah9, bl0)) | 0;
  	    hi = Math.imul(ah9, bh0);
  	    lo = (lo + Math.imul(al8, bl1)) | 0;
  	    mid = (mid + Math.imul(al8, bh1)) | 0;
  	    mid = (mid + Math.imul(ah8, bl1)) | 0;
  	    hi = (hi + Math.imul(ah8, bh1)) | 0;
  	    lo = (lo + Math.imul(al7, bl2)) | 0;
  	    mid = (mid + Math.imul(al7, bh2)) | 0;
  	    mid = (mid + Math.imul(ah7, bl2)) | 0;
  	    hi = (hi + Math.imul(ah7, bh2)) | 0;
  	    lo = (lo + Math.imul(al6, bl3)) | 0;
  	    mid = (mid + Math.imul(al6, bh3)) | 0;
  	    mid = (mid + Math.imul(ah6, bl3)) | 0;
  	    hi = (hi + Math.imul(ah6, bh3)) | 0;
  	    lo = (lo + Math.imul(al5, bl4)) | 0;
  	    mid = (mid + Math.imul(al5, bh4)) | 0;
  	    mid = (mid + Math.imul(ah5, bl4)) | 0;
  	    hi = (hi + Math.imul(ah5, bh4)) | 0;
  	    lo = (lo + Math.imul(al4, bl5)) | 0;
  	    mid = (mid + Math.imul(al4, bh5)) | 0;
  	    mid = (mid + Math.imul(ah4, bl5)) | 0;
  	    hi = (hi + Math.imul(ah4, bh5)) | 0;
  	    lo = (lo + Math.imul(al3, bl6)) | 0;
  	    mid = (mid + Math.imul(al3, bh6)) | 0;
  	    mid = (mid + Math.imul(ah3, bl6)) | 0;
  	    hi = (hi + Math.imul(ah3, bh6)) | 0;
  	    lo = (lo + Math.imul(al2, bl7)) | 0;
  	    mid = (mid + Math.imul(al2, bh7)) | 0;
  	    mid = (mid + Math.imul(ah2, bl7)) | 0;
  	    hi = (hi + Math.imul(ah2, bh7)) | 0;
  	    lo = (lo + Math.imul(al1, bl8)) | 0;
  	    mid = (mid + Math.imul(al1, bh8)) | 0;
  	    mid = (mid + Math.imul(ah1, bl8)) | 0;
  	    hi = (hi + Math.imul(ah1, bh8)) | 0;
  	    lo = (lo + Math.imul(al0, bl9)) | 0;
  	    mid = (mid + Math.imul(al0, bh9)) | 0;
  	    mid = (mid + Math.imul(ah0, bl9)) | 0;
  	    hi = (hi + Math.imul(ah0, bh9)) | 0;
  	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
  	    w9 &= 0x3ffffff;
  	    /* k = 10 */
  	    lo = Math.imul(al9, bl1);
  	    mid = Math.imul(al9, bh1);
  	    mid = (mid + Math.imul(ah9, bl1)) | 0;
  	    hi = Math.imul(ah9, bh1);
  	    lo = (lo + Math.imul(al8, bl2)) | 0;
  	    mid = (mid + Math.imul(al8, bh2)) | 0;
  	    mid = (mid + Math.imul(ah8, bl2)) | 0;
  	    hi = (hi + Math.imul(ah8, bh2)) | 0;
  	    lo = (lo + Math.imul(al7, bl3)) | 0;
  	    mid = (mid + Math.imul(al7, bh3)) | 0;
  	    mid = (mid + Math.imul(ah7, bl3)) | 0;
  	    hi = (hi + Math.imul(ah7, bh3)) | 0;
  	    lo = (lo + Math.imul(al6, bl4)) | 0;
  	    mid = (mid + Math.imul(al6, bh4)) | 0;
  	    mid = (mid + Math.imul(ah6, bl4)) | 0;
  	    hi = (hi + Math.imul(ah6, bh4)) | 0;
  	    lo = (lo + Math.imul(al5, bl5)) | 0;
  	    mid = (mid + Math.imul(al5, bh5)) | 0;
  	    mid = (mid + Math.imul(ah5, bl5)) | 0;
  	    hi = (hi + Math.imul(ah5, bh5)) | 0;
  	    lo = (lo + Math.imul(al4, bl6)) | 0;
  	    mid = (mid + Math.imul(al4, bh6)) | 0;
  	    mid = (mid + Math.imul(ah4, bl6)) | 0;
  	    hi = (hi + Math.imul(ah4, bh6)) | 0;
  	    lo = (lo + Math.imul(al3, bl7)) | 0;
  	    mid = (mid + Math.imul(al3, bh7)) | 0;
  	    mid = (mid + Math.imul(ah3, bl7)) | 0;
  	    hi = (hi + Math.imul(ah3, bh7)) | 0;
  	    lo = (lo + Math.imul(al2, bl8)) | 0;
  	    mid = (mid + Math.imul(al2, bh8)) | 0;
  	    mid = (mid + Math.imul(ah2, bl8)) | 0;
  	    hi = (hi + Math.imul(ah2, bh8)) | 0;
  	    lo = (lo + Math.imul(al1, bl9)) | 0;
  	    mid = (mid + Math.imul(al1, bh9)) | 0;
  	    mid = (mid + Math.imul(ah1, bl9)) | 0;
  	    hi = (hi + Math.imul(ah1, bh9)) | 0;
  	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
  	    w10 &= 0x3ffffff;
  	    /* k = 11 */
  	    lo = Math.imul(al9, bl2);
  	    mid = Math.imul(al9, bh2);
  	    mid = (mid + Math.imul(ah9, bl2)) | 0;
  	    hi = Math.imul(ah9, bh2);
  	    lo = (lo + Math.imul(al8, bl3)) | 0;
  	    mid = (mid + Math.imul(al8, bh3)) | 0;
  	    mid = (mid + Math.imul(ah8, bl3)) | 0;
  	    hi = (hi + Math.imul(ah8, bh3)) | 0;
  	    lo = (lo + Math.imul(al7, bl4)) | 0;
  	    mid = (mid + Math.imul(al7, bh4)) | 0;
  	    mid = (mid + Math.imul(ah7, bl4)) | 0;
  	    hi = (hi + Math.imul(ah7, bh4)) | 0;
  	    lo = (lo + Math.imul(al6, bl5)) | 0;
  	    mid = (mid + Math.imul(al6, bh5)) | 0;
  	    mid = (mid + Math.imul(ah6, bl5)) | 0;
  	    hi = (hi + Math.imul(ah6, bh5)) | 0;
  	    lo = (lo + Math.imul(al5, bl6)) | 0;
  	    mid = (mid + Math.imul(al5, bh6)) | 0;
  	    mid = (mid + Math.imul(ah5, bl6)) | 0;
  	    hi = (hi + Math.imul(ah5, bh6)) | 0;
  	    lo = (lo + Math.imul(al4, bl7)) | 0;
  	    mid = (mid + Math.imul(al4, bh7)) | 0;
  	    mid = (mid + Math.imul(ah4, bl7)) | 0;
  	    hi = (hi + Math.imul(ah4, bh7)) | 0;
  	    lo = (lo + Math.imul(al3, bl8)) | 0;
  	    mid = (mid + Math.imul(al3, bh8)) | 0;
  	    mid = (mid + Math.imul(ah3, bl8)) | 0;
  	    hi = (hi + Math.imul(ah3, bh8)) | 0;
  	    lo = (lo + Math.imul(al2, bl9)) | 0;
  	    mid = (mid + Math.imul(al2, bh9)) | 0;
  	    mid = (mid + Math.imul(ah2, bl9)) | 0;
  	    hi = (hi + Math.imul(ah2, bh9)) | 0;
  	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
  	    w11 &= 0x3ffffff;
  	    /* k = 12 */
  	    lo = Math.imul(al9, bl3);
  	    mid = Math.imul(al9, bh3);
  	    mid = (mid + Math.imul(ah9, bl3)) | 0;
  	    hi = Math.imul(ah9, bh3);
  	    lo = (lo + Math.imul(al8, bl4)) | 0;
  	    mid = (mid + Math.imul(al8, bh4)) | 0;
  	    mid = (mid + Math.imul(ah8, bl4)) | 0;
  	    hi = (hi + Math.imul(ah8, bh4)) | 0;
  	    lo = (lo + Math.imul(al7, bl5)) | 0;
  	    mid = (mid + Math.imul(al7, bh5)) | 0;
  	    mid = (mid + Math.imul(ah7, bl5)) | 0;
  	    hi = (hi + Math.imul(ah7, bh5)) | 0;
  	    lo = (lo + Math.imul(al6, bl6)) | 0;
  	    mid = (mid + Math.imul(al6, bh6)) | 0;
  	    mid = (mid + Math.imul(ah6, bl6)) | 0;
  	    hi = (hi + Math.imul(ah6, bh6)) | 0;
  	    lo = (lo + Math.imul(al5, bl7)) | 0;
  	    mid = (mid + Math.imul(al5, bh7)) | 0;
  	    mid = (mid + Math.imul(ah5, bl7)) | 0;
  	    hi = (hi + Math.imul(ah5, bh7)) | 0;
  	    lo = (lo + Math.imul(al4, bl8)) | 0;
  	    mid = (mid + Math.imul(al4, bh8)) | 0;
  	    mid = (mid + Math.imul(ah4, bl8)) | 0;
  	    hi = (hi + Math.imul(ah4, bh8)) | 0;
  	    lo = (lo + Math.imul(al3, bl9)) | 0;
  	    mid = (mid + Math.imul(al3, bh9)) | 0;
  	    mid = (mid + Math.imul(ah3, bl9)) | 0;
  	    hi = (hi + Math.imul(ah3, bh9)) | 0;
  	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
  	    w12 &= 0x3ffffff;
  	    /* k = 13 */
  	    lo = Math.imul(al9, bl4);
  	    mid = Math.imul(al9, bh4);
  	    mid = (mid + Math.imul(ah9, bl4)) | 0;
  	    hi = Math.imul(ah9, bh4);
  	    lo = (lo + Math.imul(al8, bl5)) | 0;
  	    mid = (mid + Math.imul(al8, bh5)) | 0;
  	    mid = (mid + Math.imul(ah8, bl5)) | 0;
  	    hi = (hi + Math.imul(ah8, bh5)) | 0;
  	    lo = (lo + Math.imul(al7, bl6)) | 0;
  	    mid = (mid + Math.imul(al7, bh6)) | 0;
  	    mid = (mid + Math.imul(ah7, bl6)) | 0;
  	    hi = (hi + Math.imul(ah7, bh6)) | 0;
  	    lo = (lo + Math.imul(al6, bl7)) | 0;
  	    mid = (mid + Math.imul(al6, bh7)) | 0;
  	    mid = (mid + Math.imul(ah6, bl7)) | 0;
  	    hi = (hi + Math.imul(ah6, bh7)) | 0;
  	    lo = (lo + Math.imul(al5, bl8)) | 0;
  	    mid = (mid + Math.imul(al5, bh8)) | 0;
  	    mid = (mid + Math.imul(ah5, bl8)) | 0;
  	    hi = (hi + Math.imul(ah5, bh8)) | 0;
  	    lo = (lo + Math.imul(al4, bl9)) | 0;
  	    mid = (mid + Math.imul(al4, bh9)) | 0;
  	    mid = (mid + Math.imul(ah4, bl9)) | 0;
  	    hi = (hi + Math.imul(ah4, bh9)) | 0;
  	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
  	    w13 &= 0x3ffffff;
  	    /* k = 14 */
  	    lo = Math.imul(al9, bl5);
  	    mid = Math.imul(al9, bh5);
  	    mid = (mid + Math.imul(ah9, bl5)) | 0;
  	    hi = Math.imul(ah9, bh5);
  	    lo = (lo + Math.imul(al8, bl6)) | 0;
  	    mid = (mid + Math.imul(al8, bh6)) | 0;
  	    mid = (mid + Math.imul(ah8, bl6)) | 0;
  	    hi = (hi + Math.imul(ah8, bh6)) | 0;
  	    lo = (lo + Math.imul(al7, bl7)) | 0;
  	    mid = (mid + Math.imul(al7, bh7)) | 0;
  	    mid = (mid + Math.imul(ah7, bl7)) | 0;
  	    hi = (hi + Math.imul(ah7, bh7)) | 0;
  	    lo = (lo + Math.imul(al6, bl8)) | 0;
  	    mid = (mid + Math.imul(al6, bh8)) | 0;
  	    mid = (mid + Math.imul(ah6, bl8)) | 0;
  	    hi = (hi + Math.imul(ah6, bh8)) | 0;
  	    lo = (lo + Math.imul(al5, bl9)) | 0;
  	    mid = (mid + Math.imul(al5, bh9)) | 0;
  	    mid = (mid + Math.imul(ah5, bl9)) | 0;
  	    hi = (hi + Math.imul(ah5, bh9)) | 0;
  	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
  	    w14 &= 0x3ffffff;
  	    /* k = 15 */
  	    lo = Math.imul(al9, bl6);
  	    mid = Math.imul(al9, bh6);
  	    mid = (mid + Math.imul(ah9, bl6)) | 0;
  	    hi = Math.imul(ah9, bh6);
  	    lo = (lo + Math.imul(al8, bl7)) | 0;
  	    mid = (mid + Math.imul(al8, bh7)) | 0;
  	    mid = (mid + Math.imul(ah8, bl7)) | 0;
  	    hi = (hi + Math.imul(ah8, bh7)) | 0;
  	    lo = (lo + Math.imul(al7, bl8)) | 0;
  	    mid = (mid + Math.imul(al7, bh8)) | 0;
  	    mid = (mid + Math.imul(ah7, bl8)) | 0;
  	    hi = (hi + Math.imul(ah7, bh8)) | 0;
  	    lo = (lo + Math.imul(al6, bl9)) | 0;
  	    mid = (mid + Math.imul(al6, bh9)) | 0;
  	    mid = (mid + Math.imul(ah6, bl9)) | 0;
  	    hi = (hi + Math.imul(ah6, bh9)) | 0;
  	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
  	    w15 &= 0x3ffffff;
  	    /* k = 16 */
  	    lo = Math.imul(al9, bl7);
  	    mid = Math.imul(al9, bh7);
  	    mid = (mid + Math.imul(ah9, bl7)) | 0;
  	    hi = Math.imul(ah9, bh7);
  	    lo = (lo + Math.imul(al8, bl8)) | 0;
  	    mid = (mid + Math.imul(al8, bh8)) | 0;
  	    mid = (mid + Math.imul(ah8, bl8)) | 0;
  	    hi = (hi + Math.imul(ah8, bh8)) | 0;
  	    lo = (lo + Math.imul(al7, bl9)) | 0;
  	    mid = (mid + Math.imul(al7, bh9)) | 0;
  	    mid = (mid + Math.imul(ah7, bl9)) | 0;
  	    hi = (hi + Math.imul(ah7, bh9)) | 0;
  	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
  	    w16 &= 0x3ffffff;
  	    /* k = 17 */
  	    lo = Math.imul(al9, bl8);
  	    mid = Math.imul(al9, bh8);
  	    mid = (mid + Math.imul(ah9, bl8)) | 0;
  	    hi = Math.imul(ah9, bh8);
  	    lo = (lo + Math.imul(al8, bl9)) | 0;
  	    mid = (mid + Math.imul(al8, bh9)) | 0;
  	    mid = (mid + Math.imul(ah8, bl9)) | 0;
  	    hi = (hi + Math.imul(ah8, bh9)) | 0;
  	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
  	    w17 &= 0x3ffffff;
  	    /* k = 18 */
  	    lo = Math.imul(al9, bl9);
  	    mid = Math.imul(al9, bh9);
  	    mid = (mid + Math.imul(ah9, bl9)) | 0;
  	    hi = Math.imul(ah9, bh9);
  	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
  	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
  	    w18 &= 0x3ffffff;
  	    o[0] = w0;
  	    o[1] = w1;
  	    o[2] = w2;
  	    o[3] = w3;
  	    o[4] = w4;
  	    o[5] = w5;
  	    o[6] = w6;
  	    o[7] = w7;
  	    o[8] = w8;
  	    o[9] = w9;
  	    o[10] = w10;
  	    o[11] = w11;
  	    o[12] = w12;
  	    o[13] = w13;
  	    o[14] = w14;
  	    o[15] = w15;
  	    o[16] = w16;
  	    o[17] = w17;
  	    o[18] = w18;
  	    if (c !== 0) {
  	      o[19] = c;
  	      out.length++;
  	    }
  	    return out;
  	  };

  	  // Polyfill comb
  	  if (!Math.imul) {
  	    comb10MulTo = smallMulTo;
  	  }

  	  function bigMulTo (self, num, out) {
  	    out.negative = num.negative ^ self.negative;
  	    out.length = self.length + num.length;

  	    var carry = 0;
  	    var hncarry = 0;
  	    for (var k = 0; k < out.length - 1; k++) {
  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
  	      // note that ncarry could be >= 0x3ffffff
  	      var ncarry = hncarry;
  	      hncarry = 0;
  	      var rword = carry & 0x3ffffff;
  	      var maxJ = Math.min(k, num.length - 1);
  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
  	        var i = k - j;
  	        var a = self.words[i] | 0;
  	        var b = num.words[j] | 0;
  	        var r = a * b;

  	        var lo = r & 0x3ffffff;
  	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
  	        lo = (lo + rword) | 0;
  	        rword = lo & 0x3ffffff;
  	        ncarry = (ncarry + (lo >>> 26)) | 0;

  	        hncarry += ncarry >>> 26;
  	        ncarry &= 0x3ffffff;
  	      }
  	      out.words[k] = rword;
  	      carry = ncarry;
  	      ncarry = hncarry;
  	    }
  	    if (carry !== 0) {
  	      out.words[k] = carry;
  	    } else {
  	      out.length--;
  	    }

  	    return out.strip();
  	  }

  	  function jumboMulTo (self, num, out) {
  	    var fftm = new FFTM();
  	    return fftm.mulp(self, num, out);
  	  }

  	  BN.prototype.mulTo = function mulTo (num, out) {
  	    var res;
  	    var len = this.length + num.length;
  	    if (this.length === 10 && num.length === 10) {
  	      res = comb10MulTo(this, num, out);
  	    } else if (len < 63) {
  	      res = smallMulTo(this, num, out);
  	    } else if (len < 1024) {
  	      res = bigMulTo(this, num, out);
  	    } else {
  	      res = jumboMulTo(this, num, out);
  	    }

  	    return res;
  	  };

  	  // Cooley-Tukey algorithm for FFT
  	  // slightly revisited to rely on looping instead of recursion

  	  function FFTM (x, y) {
  	    this.x = x;
  	    this.y = y;
  	  }

  	  FFTM.prototype.makeRBT = function makeRBT (N) {
  	    var t = new Array(N);
  	    var l = BN.prototype._countBits(N) - 1;
  	    for (var i = 0; i < N; i++) {
  	      t[i] = this.revBin(i, l, N);
  	    }

  	    return t;
  	  };

  	  // Returns binary-reversed representation of `x`
  	  FFTM.prototype.revBin = function revBin (x, l, N) {
  	    if (x === 0 || x === N - 1) return x;

  	    var rb = 0;
  	    for (var i = 0; i < l; i++) {
  	      rb |= (x & 1) << (l - i - 1);
  	      x >>= 1;
  	    }

  	    return rb;
  	  };

  	  // Performs "tweedling" phase, therefore 'emulating'
  	  // behaviour of the recursive algorithm
  	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
  	    for (var i = 0; i < N; i++) {
  	      rtws[i] = rws[rbt[i]];
  	      itws[i] = iws[rbt[i]];
  	    }
  	  };

  	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
  	    this.permute(rbt, rws, iws, rtws, itws, N);

  	    for (var s = 1; s < N; s <<= 1) {
  	      var l = s << 1;

  	      var rtwdf = Math.cos(2 * Math.PI / l);
  	      var itwdf = Math.sin(2 * Math.PI / l);

  	      for (var p = 0; p < N; p += l) {
  	        var rtwdf_ = rtwdf;
  	        var itwdf_ = itwdf;

  	        for (var j = 0; j < s; j++) {
  	          var re = rtws[p + j];
  	          var ie = itws[p + j];

  	          var ro = rtws[p + j + s];
  	          var io = itws[p + j + s];

  	          var rx = rtwdf_ * ro - itwdf_ * io;

  	          io = rtwdf_ * io + itwdf_ * ro;
  	          ro = rx;

  	          rtws[p + j] = re + ro;
  	          itws[p + j] = ie + io;

  	          rtws[p + j + s] = re - ro;
  	          itws[p + j + s] = ie - io;

  	          /* jshint maxdepth : false */
  	          if (j !== l) {
  	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

  	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
  	            rtwdf_ = rx;
  	          }
  	        }
  	      }
  	    }
  	  };

  	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
  	    var N = Math.max(m, n) | 1;
  	    var odd = N & 1;
  	    var i = 0;
  	    for (N = N / 2 | 0; N; N = N >>> 1) {
  	      i++;
  	    }

  	    return 1 << i + 1 + odd;
  	  };

  	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
  	    if (N <= 1) return;

  	    for (var i = 0; i < N / 2; i++) {
  	      var t = rws[i];

  	      rws[i] = rws[N - i - 1];
  	      rws[N - i - 1] = t;

  	      t = iws[i];

  	      iws[i] = -iws[N - i - 1];
  	      iws[N - i - 1] = -t;
  	    }
  	  };

  	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
  	    var carry = 0;
  	    for (var i = 0; i < N / 2; i++) {
  	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
  	        Math.round(ws[2 * i] / N) +
  	        carry;

  	      ws[i] = w & 0x3ffffff;

  	      if (w < 0x4000000) {
  	        carry = 0;
  	      } else {
  	        carry = w / 0x4000000 | 0;
  	      }
  	    }

  	    return ws;
  	  };

  	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
  	    var carry = 0;
  	    for (var i = 0; i < len; i++) {
  	      carry = carry + (ws[i] | 0);

  	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
  	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
  	    }

  	    // Pad with zeroes
  	    for (i = 2 * len; i < N; ++i) {
  	      rws[i] = 0;
  	    }

  	    assert(carry === 0);
  	    assert((carry & ~0x1fff) === 0);
  	  };

  	  FFTM.prototype.stub = function stub (N) {
  	    var ph = new Array(N);
  	    for (var i = 0; i < N; i++) {
  	      ph[i] = 0;
  	    }

  	    return ph;
  	  };

  	  FFTM.prototype.mulp = function mulp (x, y, out) {
  	    var N = 2 * this.guessLen13b(x.length, y.length);

  	    var rbt = this.makeRBT(N);

  	    var _ = this.stub(N);

  	    var rws = new Array(N);
  	    var rwst = new Array(N);
  	    var iwst = new Array(N);

  	    var nrws = new Array(N);
  	    var nrwst = new Array(N);
  	    var niwst = new Array(N);

  	    var rmws = out.words;
  	    rmws.length = N;

  	    this.convert13b(x.words, x.length, rws, N);
  	    this.convert13b(y.words, y.length, nrws, N);

  	    this.transform(rws, _, rwst, iwst, N, rbt);
  	    this.transform(nrws, _, nrwst, niwst, N, rbt);

  	    for (var i = 0; i < N; i++) {
  	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
  	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
  	      rwst[i] = rx;
  	    }

  	    this.conjugate(rwst, iwst, N);
  	    this.transform(rwst, iwst, rmws, _, N, rbt);
  	    this.conjugate(rmws, _, N);
  	    this.normalize13b(rmws, N);

  	    out.negative = x.negative ^ y.negative;
  	    out.length = x.length + y.length;
  	    return out.strip();
  	  };

  	  // Multiply `this` by `num`
  	  BN.prototype.mul = function mul (num) {
  	    var out = new BN(null);
  	    out.words = new Array(this.length + num.length);
  	    return this.mulTo(num, out);
  	  };

  	  // Multiply employing FFT
  	  BN.prototype.mulf = function mulf (num) {
  	    var out = new BN(null);
  	    out.words = new Array(this.length + num.length);
  	    return jumboMulTo(this, num, out);
  	  };

  	  // In-place Multiplication
  	  BN.prototype.imul = function imul (num) {
  	    return this.clone().mulTo(num, this);
  	  };

  	  BN.prototype.imuln = function imuln (num) {
  	    assert(typeof num === 'number');
  	    assert(num < 0x4000000);

  	    // Carry
  	    var carry = 0;
  	    for (var i = 0; i < this.length; i++) {
  	      var w = (this.words[i] | 0) * num;
  	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
  	      carry >>= 26;
  	      carry += (w / 0x4000000) | 0;
  	      // NOTE: lo is 27bit maximum
  	      carry += lo >>> 26;
  	      this.words[i] = lo & 0x3ffffff;
  	    }

  	    if (carry !== 0) {
  	      this.words[i] = carry;
  	      this.length++;
  	    }

  	    return this;
  	  };

  	  BN.prototype.muln = function muln (num) {
  	    return this.clone().imuln(num);
  	  };

  	  // `this` * `this`
  	  BN.prototype.sqr = function sqr () {
  	    return this.mul(this);
  	  };

  	  // `this` * `this` in-place
  	  BN.prototype.isqr = function isqr () {
  	    return this.imul(this.clone());
  	  };

  	  // Math.pow(`this`, `num`)
  	  BN.prototype.pow = function pow (num) {
  	    var w = toBitArray(num);
  	    if (w.length === 0) return new BN(1);

  	    // Skip leading zeroes
  	    var res = this;
  	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
  	      if (w[i] !== 0) break;
  	    }

  	    if (++i < w.length) {
  	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
  	        if (w[i] === 0) continue;

  	        res = res.mul(q);
  	      }
  	    }

  	    return res;
  	  };

  	  // Shift-left in-place
  	  BN.prototype.iushln = function iushln (bits) {
  	    assert(typeof bits === 'number' && bits >= 0);
  	    var r = bits % 26;
  	    var s = (bits - r) / 26;
  	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
  	    var i;

  	    if (r !== 0) {
  	      var carry = 0;

  	      for (i = 0; i < this.length; i++) {
  	        var newCarry = this.words[i] & carryMask;
  	        var c = ((this.words[i] | 0) - newCarry) << r;
  	        this.words[i] = c | carry;
  	        carry = newCarry >>> (26 - r);
  	      }

  	      if (carry) {
  	        this.words[i] = carry;
  	        this.length++;
  	      }
  	    }

  	    if (s !== 0) {
  	      for (i = this.length - 1; i >= 0; i--) {
  	        this.words[i + s] = this.words[i];
  	      }

  	      for (i = 0; i < s; i++) {
  	        this.words[i] = 0;
  	      }

  	      this.length += s;
  	    }

  	    return this.strip();
  	  };

  	  BN.prototype.ishln = function ishln (bits) {
  	    // TODO(indutny): implement me
  	    assert(this.negative === 0);
  	    return this.iushln(bits);
  	  };

  	  // Shift-right in-place
  	  // NOTE: `hint` is a lowest bit before trailing zeroes
  	  // NOTE: if `extended` is present - it will be filled with destroyed bits
  	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
  	    assert(typeof bits === 'number' && bits >= 0);
  	    var h;
  	    if (hint) {
  	      h = (hint - (hint % 26)) / 26;
  	    } else {
  	      h = 0;
  	    }

  	    var r = bits % 26;
  	    var s = Math.min((bits - r) / 26, this.length);
  	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
  	    var maskedWords = extended;

  	    h -= s;
  	    h = Math.max(0, h);

  	    // Extended mode, copy masked part
  	    if (maskedWords) {
  	      for (var i = 0; i < s; i++) {
  	        maskedWords.words[i] = this.words[i];
  	      }
  	      maskedWords.length = s;
  	    }

  	    if (s === 0) ; else if (this.length > s) {
  	      this.length -= s;
  	      for (i = 0; i < this.length; i++) {
  	        this.words[i] = this.words[i + s];
  	      }
  	    } else {
  	      this.words[0] = 0;
  	      this.length = 1;
  	    }

  	    var carry = 0;
  	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
  	      var word = this.words[i] | 0;
  	      this.words[i] = (carry << (26 - r)) | (word >>> r);
  	      carry = word & mask;
  	    }

  	    // Push carried bits as a mask
  	    if (maskedWords && carry !== 0) {
  	      maskedWords.words[maskedWords.length++] = carry;
  	    }

  	    if (this.length === 0) {
  	      this.words[0] = 0;
  	      this.length = 1;
  	    }

  	    return this.strip();
  	  };

  	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
  	    // TODO(indutny): implement me
  	    assert(this.negative === 0);
  	    return this.iushrn(bits, hint, extended);
  	  };

  	  // Shift-left
  	  BN.prototype.shln = function shln (bits) {
  	    return this.clone().ishln(bits);
  	  };

  	  BN.prototype.ushln = function ushln (bits) {
  	    return this.clone().iushln(bits);
  	  };

  	  // Shift-right
  	  BN.prototype.shrn = function shrn (bits) {
  	    return this.clone().ishrn(bits);
  	  };

  	  BN.prototype.ushrn = function ushrn (bits) {
  	    return this.clone().iushrn(bits);
  	  };

  	  // Test if n bit is set
  	  BN.prototype.testn = function testn (bit) {
  	    assert(typeof bit === 'number' && bit >= 0);
  	    var r = bit % 26;
  	    var s = (bit - r) / 26;
  	    var q = 1 << r;

  	    // Fast case: bit is much higher than all existing words
  	    if (this.length <= s) return false;

  	    // Check bit and return
  	    var w = this.words[s];

  	    return !!(w & q);
  	  };

  	  // Return only lowers bits of number (in-place)
  	  BN.prototype.imaskn = function imaskn (bits) {
  	    assert(typeof bits === 'number' && bits >= 0);
  	    var r = bits % 26;
  	    var s = (bits - r) / 26;

  	    assert(this.negative === 0, 'imaskn works only with positive numbers');

  	    if (this.length <= s) {
  	      return this;
  	    }

  	    if (r !== 0) {
  	      s++;
  	    }
  	    this.length = Math.min(s, this.length);

  	    if (r !== 0) {
  	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
  	      this.words[this.length - 1] &= mask;
  	    }

  	    return this.strip();
  	  };

  	  // Return only lowers bits of number
  	  BN.prototype.maskn = function maskn (bits) {
  	    return this.clone().imaskn(bits);
  	  };

  	  // Add plain number `num` to `this`
  	  BN.prototype.iaddn = function iaddn (num) {
  	    assert(typeof num === 'number');
  	    assert(num < 0x4000000);
  	    if (num < 0) return this.isubn(-num);

  	    // Possible sign change
  	    if (this.negative !== 0) {
  	      if (this.length === 1 && (this.words[0] | 0) < num) {
  	        this.words[0] = num - (this.words[0] | 0);
  	        this.negative = 0;
  	        return this;
  	      }

  	      this.negative = 0;
  	      this.isubn(num);
  	      this.negative = 1;
  	      return this;
  	    }

  	    // Add without checks
  	    return this._iaddn(num);
  	  };

  	  BN.prototype._iaddn = function _iaddn (num) {
  	    this.words[0] += num;

  	    // Carry
  	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
  	      this.words[i] -= 0x4000000;
  	      if (i === this.length - 1) {
  	        this.words[i + 1] = 1;
  	      } else {
  	        this.words[i + 1]++;
  	      }
  	    }
  	    this.length = Math.max(this.length, i + 1);

  	    return this;
  	  };

  	  // Subtract plain number `num` from `this`
  	  BN.prototype.isubn = function isubn (num) {
  	    assert(typeof num === 'number');
  	    assert(num < 0x4000000);
  	    if (num < 0) return this.iaddn(-num);

  	    if (this.negative !== 0) {
  	      this.negative = 0;
  	      this.iaddn(num);
  	      this.negative = 1;
  	      return this;
  	    }

  	    this.words[0] -= num;

  	    if (this.length === 1 && this.words[0] < 0) {
  	      this.words[0] = -this.words[0];
  	      this.negative = 1;
  	    } else {
  	      // Carry
  	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
  	        this.words[i] += 0x4000000;
  	        this.words[i + 1] -= 1;
  	      }
  	    }

  	    return this.strip();
  	  };

  	  BN.prototype.addn = function addn (num) {
  	    return this.clone().iaddn(num);
  	  };

  	  BN.prototype.subn = function subn (num) {
  	    return this.clone().isubn(num);
  	  };

  	  BN.prototype.iabs = function iabs () {
  	    this.negative = 0;

  	    return this;
  	  };

  	  BN.prototype.abs = function abs () {
  	    return this.clone().iabs();
  	  };

  	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
  	    var len = num.length + shift;
  	    var i;

  	    this._expand(len);

  	    var w;
  	    var carry = 0;
  	    for (i = 0; i < num.length; i++) {
  	      w = (this.words[i + shift] | 0) + carry;
  	      var right = (num.words[i] | 0) * mul;
  	      w -= right & 0x3ffffff;
  	      carry = (w >> 26) - ((right / 0x4000000) | 0);
  	      this.words[i + shift] = w & 0x3ffffff;
  	    }
  	    for (; i < this.length - shift; i++) {
  	      w = (this.words[i + shift] | 0) + carry;
  	      carry = w >> 26;
  	      this.words[i + shift] = w & 0x3ffffff;
  	    }

  	    if (carry === 0) return this.strip();

  	    // Subtraction overflow
  	    assert(carry === -1);
  	    carry = 0;
  	    for (i = 0; i < this.length; i++) {
  	      w = -(this.words[i] | 0) + carry;
  	      carry = w >> 26;
  	      this.words[i] = w & 0x3ffffff;
  	    }
  	    this.negative = 1;

  	    return this.strip();
  	  };

  	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
  	    var shift = this.length - num.length;

  	    var a = this.clone();
  	    var b = num;

  	    // Normalize
  	    var bhi = b.words[b.length - 1] | 0;
  	    var bhiBits = this._countBits(bhi);
  	    shift = 26 - bhiBits;
  	    if (shift !== 0) {
  	      b = b.ushln(shift);
  	      a.iushln(shift);
  	      bhi = b.words[b.length - 1] | 0;
  	    }

  	    // Initialize quotient
  	    var m = a.length - b.length;
  	    var q;

  	    if (mode !== 'mod') {
  	      q = new BN(null);
  	      q.length = m + 1;
  	      q.words = new Array(q.length);
  	      for (var i = 0; i < q.length; i++) {
  	        q.words[i] = 0;
  	      }
  	    }

  	    var diff = a.clone()._ishlnsubmul(b, 1, m);
  	    if (diff.negative === 0) {
  	      a = diff;
  	      if (q) {
  	        q.words[m] = 1;
  	      }
  	    }

  	    for (var j = m - 1; j >= 0; j--) {
  	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
  	        (a.words[b.length + j - 1] | 0);

  	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
  	      // (0x7ffffff)
  	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

  	      a._ishlnsubmul(b, qj, j);
  	      while (a.negative !== 0) {
  	        qj--;
  	        a.negative = 0;
  	        a._ishlnsubmul(b, 1, j);
  	        if (!a.isZero()) {
  	          a.negative ^= 1;
  	        }
  	      }
  	      if (q) {
  	        q.words[j] = qj;
  	      }
  	    }
  	    if (q) {
  	      q.strip();
  	    }
  	    a.strip();

  	    // Denormalize
  	    if (mode !== 'div' && shift !== 0) {
  	      a.iushrn(shift);
  	    }

  	    return {
  	      div: q || null,
  	      mod: a
  	    };
  	  };

  	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  	  //       to `div` to request div only, or be absent to
  	  //       request both div & mod
  	  //       2) `positive` is true if unsigned mod is requested
  	  BN.prototype.divmod = function divmod (num, mode, positive) {
  	    assert(!num.isZero());

  	    if (this.isZero()) {
  	      return {
  	        div: new BN(0),
  	        mod: new BN(0)
  	      };
  	    }

  	    var div, mod, res;
  	    if (this.negative !== 0 && num.negative === 0) {
  	      res = this.neg().divmod(num, mode);

  	      if (mode !== 'mod') {
  	        div = res.div.neg();
  	      }

  	      if (mode !== 'div') {
  	        mod = res.mod.neg();
  	        if (positive && mod.negative !== 0) {
  	          mod.iadd(num);
  	        }
  	      }

  	      return {
  	        div: div,
  	        mod: mod
  	      };
  	    }

  	    if (this.negative === 0 && num.negative !== 0) {
  	      res = this.divmod(num.neg(), mode);

  	      if (mode !== 'mod') {
  	        div = res.div.neg();
  	      }

  	      return {
  	        div: div,
  	        mod: res.mod
  	      };
  	    }

  	    if ((this.negative & num.negative) !== 0) {
  	      res = this.neg().divmod(num.neg(), mode);

  	      if (mode !== 'div') {
  	        mod = res.mod.neg();
  	        if (positive && mod.negative !== 0) {
  	          mod.isub(num);
  	        }
  	      }

  	      return {
  	        div: res.div,
  	        mod: mod
  	      };
  	    }

  	    // Both numbers are positive at this point

  	    // Strip both numbers to approximate shift value
  	    if (num.length > this.length || this.cmp(num) < 0) {
  	      return {
  	        div: new BN(0),
  	        mod: this
  	      };
  	    }

  	    // Very short reduction
  	    if (num.length === 1) {
  	      if (mode === 'div') {
  	        return {
  	          div: this.divn(num.words[0]),
  	          mod: null
  	        };
  	      }

  	      if (mode === 'mod') {
  	        return {
  	          div: null,
  	          mod: new BN(this.modn(num.words[0]))
  	        };
  	      }

  	      return {
  	        div: this.divn(num.words[0]),
  	        mod: new BN(this.modn(num.words[0]))
  	      };
  	    }

  	    return this._wordDiv(num, mode);
  	  };

  	  // Find `this` / `num`
  	  BN.prototype.div = function div (num) {
  	    return this.divmod(num, 'div', false).div;
  	  };

  	  // Find `this` % `num`
  	  BN.prototype.mod = function mod (num) {
  	    return this.divmod(num, 'mod', false).mod;
  	  };

  	  BN.prototype.umod = function umod (num) {
  	    return this.divmod(num, 'mod', true).mod;
  	  };

  	  // Find Round(`this` / `num`)
  	  BN.prototype.divRound = function divRound (num) {
  	    var dm = this.divmod(num);

  	    // Fast case - exact division
  	    if (dm.mod.isZero()) return dm.div;

  	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

  	    var half = num.ushrn(1);
  	    var r2 = num.andln(1);
  	    var cmp = mod.cmp(half);

  	    // Round down
  	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

  	    // Round up
  	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  	  };

  	  BN.prototype.modn = function modn (num) {
  	    assert(num <= 0x3ffffff);
  	    var p = (1 << 26) % num;

  	    var acc = 0;
  	    for (var i = this.length - 1; i >= 0; i--) {
  	      acc = (p * acc + (this.words[i] | 0)) % num;
  	    }

  	    return acc;
  	  };

  	  // In-place division by number
  	  BN.prototype.idivn = function idivn (num) {
  	    assert(num <= 0x3ffffff);

  	    var carry = 0;
  	    for (var i = this.length - 1; i >= 0; i--) {
  	      var w = (this.words[i] | 0) + carry * 0x4000000;
  	      this.words[i] = (w / num) | 0;
  	      carry = w % num;
  	    }

  	    return this.strip();
  	  };

  	  BN.prototype.divn = function divn (num) {
  	    return this.clone().idivn(num);
  	  };

  	  BN.prototype.egcd = function egcd (p) {
  	    assert(p.negative === 0);
  	    assert(!p.isZero());

  	    var x = this;
  	    var y = p.clone();

  	    if (x.negative !== 0) {
  	      x = x.umod(p);
  	    } else {
  	      x = x.clone();
  	    }

  	    // A * x + B * y = x
  	    var A = new BN(1);
  	    var B = new BN(0);

  	    // C * x + D * y = y
  	    var C = new BN(0);
  	    var D = new BN(1);

  	    var g = 0;

  	    while (x.isEven() && y.isEven()) {
  	      x.iushrn(1);
  	      y.iushrn(1);
  	      ++g;
  	    }

  	    var yp = y.clone();
  	    var xp = x.clone();

  	    while (!x.isZero()) {
  	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
  	      if (i > 0) {
  	        x.iushrn(i);
  	        while (i-- > 0) {
  	          if (A.isOdd() || B.isOdd()) {
  	            A.iadd(yp);
  	            B.isub(xp);
  	          }

  	          A.iushrn(1);
  	          B.iushrn(1);
  	        }
  	      }

  	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
  	      if (j > 0) {
  	        y.iushrn(j);
  	        while (j-- > 0) {
  	          if (C.isOdd() || D.isOdd()) {
  	            C.iadd(yp);
  	            D.isub(xp);
  	          }

  	          C.iushrn(1);
  	          D.iushrn(1);
  	        }
  	      }

  	      if (x.cmp(y) >= 0) {
  	        x.isub(y);
  	        A.isub(C);
  	        B.isub(D);
  	      } else {
  	        y.isub(x);
  	        C.isub(A);
  	        D.isub(B);
  	      }
  	    }

  	    return {
  	      a: C,
  	      b: D,
  	      gcd: y.iushln(g)
  	    };
  	  };

  	  // This is reduced incarnation of the binary EEA
  	  // above, designated to invert members of the
  	  // _prime_ fields F(p) at a maximal speed
  	  BN.prototype._invmp = function _invmp (p) {
  	    assert(p.negative === 0);
  	    assert(!p.isZero());

  	    var a = this;
  	    var b = p.clone();

  	    if (a.negative !== 0) {
  	      a = a.umod(p);
  	    } else {
  	      a = a.clone();
  	    }

  	    var x1 = new BN(1);
  	    var x2 = new BN(0);

  	    var delta = b.clone();

  	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
  	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
  	      if (i > 0) {
  	        a.iushrn(i);
  	        while (i-- > 0) {
  	          if (x1.isOdd()) {
  	            x1.iadd(delta);
  	          }

  	          x1.iushrn(1);
  	        }
  	      }

  	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
  	      if (j > 0) {
  	        b.iushrn(j);
  	        while (j-- > 0) {
  	          if (x2.isOdd()) {
  	            x2.iadd(delta);
  	          }

  	          x2.iushrn(1);
  	        }
  	      }

  	      if (a.cmp(b) >= 0) {
  	        a.isub(b);
  	        x1.isub(x2);
  	      } else {
  	        b.isub(a);
  	        x2.isub(x1);
  	      }
  	    }

  	    var res;
  	    if (a.cmpn(1) === 0) {
  	      res = x1;
  	    } else {
  	      res = x2;
  	    }

  	    if (res.cmpn(0) < 0) {
  	      res.iadd(p);
  	    }

  	    return res;
  	  };

  	  BN.prototype.gcd = function gcd (num) {
  	    if (this.isZero()) return num.abs();
  	    if (num.isZero()) return this.abs();

  	    var a = this.clone();
  	    var b = num.clone();
  	    a.negative = 0;
  	    b.negative = 0;

  	    // Remove common factor of two
  	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
  	      a.iushrn(1);
  	      b.iushrn(1);
  	    }

  	    do {
  	      while (a.isEven()) {
  	        a.iushrn(1);
  	      }
  	      while (b.isEven()) {
  	        b.iushrn(1);
  	      }

  	      var r = a.cmp(b);
  	      if (r < 0) {
  	        // Swap `a` and `b` to make `a` always bigger than `b`
  	        var t = a;
  	        a = b;
  	        b = t;
  	      } else if (r === 0 || b.cmpn(1) === 0) {
  	        break;
  	      }

  	      a.isub(b);
  	    } while (true);

  	    return b.iushln(shift);
  	  };

  	  // Invert number in the field F(num)
  	  BN.prototype.invm = function invm (num) {
  	    return this.egcd(num).a.umod(num);
  	  };

  	  BN.prototype.isEven = function isEven () {
  	    return (this.words[0] & 1) === 0;
  	  };

  	  BN.prototype.isOdd = function isOdd () {
  	    return (this.words[0] & 1) === 1;
  	  };

  	  // And first word and num
  	  BN.prototype.andln = function andln (num) {
  	    return this.words[0] & num;
  	  };

  	  // Increment at the bit position in-line
  	  BN.prototype.bincn = function bincn (bit) {
  	    assert(typeof bit === 'number');
  	    var r = bit % 26;
  	    var s = (bit - r) / 26;
  	    var q = 1 << r;

  	    // Fast case: bit is much higher than all existing words
  	    if (this.length <= s) {
  	      this._expand(s + 1);
  	      this.words[s] |= q;
  	      return this;
  	    }

  	    // Add bit and propagate, if needed
  	    var carry = q;
  	    for (var i = s; carry !== 0 && i < this.length; i++) {
  	      var w = this.words[i] | 0;
  	      w += carry;
  	      carry = w >>> 26;
  	      w &= 0x3ffffff;
  	      this.words[i] = w;
  	    }
  	    if (carry !== 0) {
  	      this.words[i] = carry;
  	      this.length++;
  	    }
  	    return this;
  	  };

  	  BN.prototype.isZero = function isZero () {
  	    return this.length === 1 && this.words[0] === 0;
  	  };

  	  BN.prototype.cmpn = function cmpn (num) {
  	    var negative = num < 0;

  	    if (this.negative !== 0 && !negative) return -1;
  	    if (this.negative === 0 && negative) return 1;

  	    this.strip();

  	    var res;
  	    if (this.length > 1) {
  	      res = 1;
  	    } else {
  	      if (negative) {
  	        num = -num;
  	      }

  	      assert(num <= 0x3ffffff, 'Number is too big');

  	      var w = this.words[0] | 0;
  	      res = w === num ? 0 : w < num ? -1 : 1;
  	    }
  	    if (this.negative !== 0) return -res | 0;
  	    return res;
  	  };

  	  // Compare two numbers and return:
  	  // 1 - if `this` > `num`
  	  // 0 - if `this` == `num`
  	  // -1 - if `this` < `num`
  	  BN.prototype.cmp = function cmp (num) {
  	    if (this.negative !== 0 && num.negative === 0) return -1;
  	    if (this.negative === 0 && num.negative !== 0) return 1;

  	    var res = this.ucmp(num);
  	    if (this.negative !== 0) return -res | 0;
  	    return res;
  	  };

  	  // Unsigned comparison
  	  BN.prototype.ucmp = function ucmp (num) {
  	    // At this point both numbers have the same sign
  	    if (this.length > num.length) return 1;
  	    if (this.length < num.length) return -1;

  	    var res = 0;
  	    for (var i = this.length - 1; i >= 0; i--) {
  	      var a = this.words[i] | 0;
  	      var b = num.words[i] | 0;

  	      if (a === b) continue;
  	      if (a < b) {
  	        res = -1;
  	      } else if (a > b) {
  	        res = 1;
  	      }
  	      break;
  	    }
  	    return res;
  	  };

  	  BN.prototype.gtn = function gtn (num) {
  	    return this.cmpn(num) === 1;
  	  };

  	  BN.prototype.gt = function gt (num) {
  	    return this.cmp(num) === 1;
  	  };

  	  BN.prototype.gten = function gten (num) {
  	    return this.cmpn(num) >= 0;
  	  };

  	  BN.prototype.gte = function gte (num) {
  	    return this.cmp(num) >= 0;
  	  };

  	  BN.prototype.ltn = function ltn (num) {
  	    return this.cmpn(num) === -1;
  	  };

  	  BN.prototype.lt = function lt (num) {
  	    return this.cmp(num) === -1;
  	  };

  	  BN.prototype.lten = function lten (num) {
  	    return this.cmpn(num) <= 0;
  	  };

  	  BN.prototype.lte = function lte (num) {
  	    return this.cmp(num) <= 0;
  	  };

  	  BN.prototype.eqn = function eqn (num) {
  	    return this.cmpn(num) === 0;
  	  };

  	  BN.prototype.eq = function eq (num) {
  	    return this.cmp(num) === 0;
  	  };

  	  //
  	  // A reduce context, could be using montgomery or something better, depending
  	  // on the `m` itself.
  	  //
  	  BN.red = function red (num) {
  	    return new Red(num);
  	  };

  	  BN.prototype.toRed = function toRed (ctx) {
  	    assert(!this.red, 'Already a number in reduction context');
  	    assert(this.negative === 0, 'red works only with positives');
  	    return ctx.convertTo(this)._forceRed(ctx);
  	  };

  	  BN.prototype.fromRed = function fromRed () {
  	    assert(this.red, 'fromRed works only with numbers in reduction context');
  	    return this.red.convertFrom(this);
  	  };

  	  BN.prototype._forceRed = function _forceRed (ctx) {
  	    this.red = ctx;
  	    return this;
  	  };

  	  BN.prototype.forceRed = function forceRed (ctx) {
  	    assert(!this.red, 'Already a number in reduction context');
  	    return this._forceRed(ctx);
  	  };

  	  BN.prototype.redAdd = function redAdd (num) {
  	    assert(this.red, 'redAdd works only with red numbers');
  	    return this.red.add(this, num);
  	  };

  	  BN.prototype.redIAdd = function redIAdd (num) {
  	    assert(this.red, 'redIAdd works only with red numbers');
  	    return this.red.iadd(this, num);
  	  };

  	  BN.prototype.redSub = function redSub (num) {
  	    assert(this.red, 'redSub works only with red numbers');
  	    return this.red.sub(this, num);
  	  };

  	  BN.prototype.redISub = function redISub (num) {
  	    assert(this.red, 'redISub works only with red numbers');
  	    return this.red.isub(this, num);
  	  };

  	  BN.prototype.redShl = function redShl (num) {
  	    assert(this.red, 'redShl works only with red numbers');
  	    return this.red.shl(this, num);
  	  };

  	  BN.prototype.redMul = function redMul (num) {
  	    assert(this.red, 'redMul works only with red numbers');
  	    this.red._verify2(this, num);
  	    return this.red.mul(this, num);
  	  };

  	  BN.prototype.redIMul = function redIMul (num) {
  	    assert(this.red, 'redMul works only with red numbers');
  	    this.red._verify2(this, num);
  	    return this.red.imul(this, num);
  	  };

  	  BN.prototype.redSqr = function redSqr () {
  	    assert(this.red, 'redSqr works only with red numbers');
  	    this.red._verify1(this);
  	    return this.red.sqr(this);
  	  };

  	  BN.prototype.redISqr = function redISqr () {
  	    assert(this.red, 'redISqr works only with red numbers');
  	    this.red._verify1(this);
  	    return this.red.isqr(this);
  	  };

  	  // Square root over p
  	  BN.prototype.redSqrt = function redSqrt () {
  	    assert(this.red, 'redSqrt works only with red numbers');
  	    this.red._verify1(this);
  	    return this.red.sqrt(this);
  	  };

  	  BN.prototype.redInvm = function redInvm () {
  	    assert(this.red, 'redInvm works only with red numbers');
  	    this.red._verify1(this);
  	    return this.red.invm(this);
  	  };

  	  // Return negative clone of `this` % `red modulo`
  	  BN.prototype.redNeg = function redNeg () {
  	    assert(this.red, 'redNeg works only with red numbers');
  	    this.red._verify1(this);
  	    return this.red.neg(this);
  	  };

  	  BN.prototype.redPow = function redPow (num) {
  	    assert(this.red && !num.red, 'redPow(normalNum)');
  	    this.red._verify1(this);
  	    return this.red.pow(this, num);
  	  };

  	  // Prime numbers with efficient reduction
  	  var primes = {
  	    k256: null,
  	    p224: null,
  	    p192: null,
  	    p25519: null
  	  };

  	  // Pseudo-Mersenne prime
  	  function MPrime (name, p) {
  	    // P = 2 ^ N - K
  	    this.name = name;
  	    this.p = new BN(p, 16);
  	    this.n = this.p.bitLength();
  	    this.k = new BN(1).iushln(this.n).isub(this.p);

  	    this.tmp = this._tmp();
  	  }

  	  MPrime.prototype._tmp = function _tmp () {
  	    var tmp = new BN(null);
  	    tmp.words = new Array(Math.ceil(this.n / 13));
  	    return tmp;
  	  };

  	  MPrime.prototype.ireduce = function ireduce (num) {
  	    // Assumes that `num` is less than `P^2`
  	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
  	    var r = num;
  	    var rlen;

  	    do {
  	      this.split(r, this.tmp);
  	      r = this.imulK(r);
  	      r = r.iadd(this.tmp);
  	      rlen = r.bitLength();
  	    } while (rlen > this.n);

  	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
  	    if (cmp === 0) {
  	      r.words[0] = 0;
  	      r.length = 1;
  	    } else if (cmp > 0) {
  	      r.isub(this.p);
  	    } else {
  	      if (r.strip !== undefined) {
  	        // r is BN v4 instance
  	        r.strip();
  	      } else {
  	        // r is BN v5 instance
  	        r._strip();
  	      }
  	    }

  	    return r;
  	  };

  	  MPrime.prototype.split = function split (input, out) {
  	    input.iushrn(this.n, 0, out);
  	  };

  	  MPrime.prototype.imulK = function imulK (num) {
  	    return num.imul(this.k);
  	  };

  	  function K256 () {
  	    MPrime.call(
  	      this,
  	      'k256',
  	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  	  }
  	  inherits(K256, MPrime);

  	  K256.prototype.split = function split (input, output) {
  	    // 256 = 9 * 26 + 22
  	    var mask = 0x3fffff;

  	    var outLen = Math.min(input.length, 9);
  	    for (var i = 0; i < outLen; i++) {
  	      output.words[i] = input.words[i];
  	    }
  	    output.length = outLen;

  	    if (input.length <= 9) {
  	      input.words[0] = 0;
  	      input.length = 1;
  	      return;
  	    }

  	    // Shift by 9 limbs
  	    var prev = input.words[9];
  	    output.words[output.length++] = prev & mask;

  	    for (i = 10; i < input.length; i++) {
  	      var next = input.words[i] | 0;
  	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
  	      prev = next;
  	    }
  	    prev >>>= 22;
  	    input.words[i - 10] = prev;
  	    if (prev === 0 && input.length > 10) {
  	      input.length -= 10;
  	    } else {
  	      input.length -= 9;
  	    }
  	  };

  	  K256.prototype.imulK = function imulK (num) {
  	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
  	    num.words[num.length] = 0;
  	    num.words[num.length + 1] = 0;
  	    num.length += 2;

  	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
  	    var lo = 0;
  	    for (var i = 0; i < num.length; i++) {
  	      var w = num.words[i] | 0;
  	      lo += w * 0x3d1;
  	      num.words[i] = lo & 0x3ffffff;
  	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
  	    }

  	    // Fast length reduction
  	    if (num.words[num.length - 1] === 0) {
  	      num.length--;
  	      if (num.words[num.length - 1] === 0) {
  	        num.length--;
  	      }
  	    }
  	    return num;
  	  };

  	  function P224 () {
  	    MPrime.call(
  	      this,
  	      'p224',
  	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  	  }
  	  inherits(P224, MPrime);

  	  function P192 () {
  	    MPrime.call(
  	      this,
  	      'p192',
  	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  	  }
  	  inherits(P192, MPrime);

  	  function P25519 () {
  	    // 2 ^ 255 - 19
  	    MPrime.call(
  	      this,
  	      '25519',
  	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  	  }
  	  inherits(P25519, MPrime);

  	  P25519.prototype.imulK = function imulK (num) {
  	    // K = 0x13
  	    var carry = 0;
  	    for (var i = 0; i < num.length; i++) {
  	      var hi = (num.words[i] | 0) * 0x13 + carry;
  	      var lo = hi & 0x3ffffff;
  	      hi >>>= 26;

  	      num.words[i] = lo;
  	      carry = hi;
  	    }
  	    if (carry !== 0) {
  	      num.words[num.length++] = carry;
  	    }
  	    return num;
  	  };

  	  // Exported mostly for testing purposes, use plain name instead
  	  BN._prime = function prime (name) {
  	    // Cached version of prime
  	    if (primes[name]) return primes[name];

  	    var prime;
  	    if (name === 'k256') {
  	      prime = new K256();
  	    } else if (name === 'p224') {
  	      prime = new P224();
  	    } else if (name === 'p192') {
  	      prime = new P192();
  	    } else if (name === 'p25519') {
  	      prime = new P25519();
  	    } else {
  	      throw new Error('Unknown prime ' + name);
  	    }
  	    primes[name] = prime;

  	    return prime;
  	  };

  	  //
  	  // Base reduction engine
  	  //
  	  function Red (m) {
  	    if (typeof m === 'string') {
  	      var prime = BN._prime(m);
  	      this.m = prime.p;
  	      this.prime = prime;
  	    } else {
  	      assert(m.gtn(1), 'modulus must be greater than 1');
  	      this.m = m;
  	      this.prime = null;
  	    }
  	  }

  	  Red.prototype._verify1 = function _verify1 (a) {
  	    assert(a.negative === 0, 'red works only with positives');
  	    assert(a.red, 'red works only with red numbers');
  	  };

  	  Red.prototype._verify2 = function _verify2 (a, b) {
  	    assert((a.negative | b.negative) === 0, 'red works only with positives');
  	    assert(a.red && a.red === b.red,
  	      'red works only with red numbers');
  	  };

  	  Red.prototype.imod = function imod (a) {
  	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
  	    return a.umod(this.m)._forceRed(this);
  	  };

  	  Red.prototype.neg = function neg (a) {
  	    if (a.isZero()) {
  	      return a.clone();
  	    }

  	    return this.m.sub(a)._forceRed(this);
  	  };

  	  Red.prototype.add = function add (a, b) {
  	    this._verify2(a, b);

  	    var res = a.add(b);
  	    if (res.cmp(this.m) >= 0) {
  	      res.isub(this.m);
  	    }
  	    return res._forceRed(this);
  	  };

  	  Red.prototype.iadd = function iadd (a, b) {
  	    this._verify2(a, b);

  	    var res = a.iadd(b);
  	    if (res.cmp(this.m) >= 0) {
  	      res.isub(this.m);
  	    }
  	    return res;
  	  };

  	  Red.prototype.sub = function sub (a, b) {
  	    this._verify2(a, b);

  	    var res = a.sub(b);
  	    if (res.cmpn(0) < 0) {
  	      res.iadd(this.m);
  	    }
  	    return res._forceRed(this);
  	  };

  	  Red.prototype.isub = function isub (a, b) {
  	    this._verify2(a, b);

  	    var res = a.isub(b);
  	    if (res.cmpn(0) < 0) {
  	      res.iadd(this.m);
  	    }
  	    return res;
  	  };

  	  Red.prototype.shl = function shl (a, num) {
  	    this._verify1(a);
  	    return this.imod(a.ushln(num));
  	  };

  	  Red.prototype.imul = function imul (a, b) {
  	    this._verify2(a, b);
  	    return this.imod(a.imul(b));
  	  };

  	  Red.prototype.mul = function mul (a, b) {
  	    this._verify2(a, b);
  	    return this.imod(a.mul(b));
  	  };

  	  Red.prototype.isqr = function isqr (a) {
  	    return this.imul(a, a.clone());
  	  };

  	  Red.prototype.sqr = function sqr (a) {
  	    return this.mul(a, a);
  	  };

  	  Red.prototype.sqrt = function sqrt (a) {
  	    if (a.isZero()) return a.clone();

  	    var mod3 = this.m.andln(3);
  	    assert(mod3 % 2 === 1);

  	    // Fast case
  	    if (mod3 === 3) {
  	      var pow = this.m.add(new BN(1)).iushrn(2);
  	      return this.pow(a, pow);
  	    }

  	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
  	    //
  	    // Find Q and S, that Q * 2 ^ S = (P - 1)
  	    var q = this.m.subn(1);
  	    var s = 0;
  	    while (!q.isZero() && q.andln(1) === 0) {
  	      s++;
  	      q.iushrn(1);
  	    }
  	    assert(!q.isZero());

  	    var one = new BN(1).toRed(this);
  	    var nOne = one.redNeg();

  	    // Find quadratic non-residue
  	    // NOTE: Max is such because of generalized Riemann hypothesis.
  	    var lpow = this.m.subn(1).iushrn(1);
  	    var z = this.m.bitLength();
  	    z = new BN(2 * z * z).toRed(this);

  	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
  	      z.redIAdd(nOne);
  	    }

  	    var c = this.pow(z, q);
  	    var r = this.pow(a, q.addn(1).iushrn(1));
  	    var t = this.pow(a, q);
  	    var m = s;
  	    while (t.cmp(one) !== 0) {
  	      var tmp = t;
  	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
  	        tmp = tmp.redSqr();
  	      }
  	      assert(i < m);
  	      var b = this.pow(c, new BN(1).iushln(m - i - 1));

  	      r = r.redMul(b);
  	      c = b.redSqr();
  	      t = t.redMul(c);
  	      m = i;
  	    }

  	    return r;
  	  };

  	  Red.prototype.invm = function invm (a) {
  	    var inv = a._invmp(this.m);
  	    if (inv.negative !== 0) {
  	      inv.negative = 0;
  	      return this.imod(inv).redNeg();
  	    } else {
  	      return this.imod(inv);
  	    }
  	  };

  	  Red.prototype.pow = function pow (a, num) {
  	    if (num.isZero()) return new BN(1).toRed(this);
  	    if (num.cmpn(1) === 0) return a.clone();

  	    var windowSize = 4;
  	    var wnd = new Array(1 << windowSize);
  	    wnd[0] = new BN(1).toRed(this);
  	    wnd[1] = a;
  	    for (var i = 2; i < wnd.length; i++) {
  	      wnd[i] = this.mul(wnd[i - 1], a);
  	    }

  	    var res = wnd[0];
  	    var current = 0;
  	    var currentLen = 0;
  	    var start = num.bitLength() % 26;
  	    if (start === 0) {
  	      start = 26;
  	    }

  	    for (i = num.length - 1; i >= 0; i--) {
  	      var word = num.words[i];
  	      for (var j = start - 1; j >= 0; j--) {
  	        var bit = (word >> j) & 1;
  	        if (res !== wnd[0]) {
  	          res = this.sqr(res);
  	        }

  	        if (bit === 0 && current === 0) {
  	          currentLen = 0;
  	          continue;
  	        }

  	        current <<= 1;
  	        current |= bit;
  	        currentLen++;
  	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

  	        res = this.mul(res, wnd[current]);
  	        currentLen = 0;
  	        current = 0;
  	      }
  	      start = 26;
  	    }

  	    return res;
  	  };

  	  Red.prototype.convertTo = function convertTo (num) {
  	    var r = num.umod(this.m);

  	    return r === num ? r.clone() : r;
  	  };

  	  Red.prototype.convertFrom = function convertFrom (num) {
  	    var res = num.clone();
  	    res.red = null;
  	    return res;
  	  };

  	  //
  	  // Montgomery method engine
  	  //

  	  BN.mont = function mont (num) {
  	    return new Mont(num);
  	  };

  	  function Mont (m) {
  	    Red.call(this, m);

  	    this.shift = this.m.bitLength();
  	    if (this.shift % 26 !== 0) {
  	      this.shift += 26 - (this.shift % 26);
  	    }

  	    this.r = new BN(1).iushln(this.shift);
  	    this.r2 = this.imod(this.r.sqr());
  	    this.rinv = this.r._invmp(this.m);

  	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
  	    this.minv = this.minv.umod(this.r);
  	    this.minv = this.r.sub(this.minv);
  	  }
  	  inherits(Mont, Red);

  	  Mont.prototype.convertTo = function convertTo (num) {
  	    return this.imod(num.ushln(this.shift));
  	  };

  	  Mont.prototype.convertFrom = function convertFrom (num) {
  	    var r = this.imod(num.mul(this.rinv));
  	    r.red = null;
  	    return r;
  	  };

  	  Mont.prototype.imul = function imul (a, b) {
  	    if (a.isZero() || b.isZero()) {
  	      a.words[0] = 0;
  	      a.length = 1;
  	      return a;
  	    }

  	    var t = a.imul(b);
  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
  	    var u = t.isub(c).iushrn(this.shift);
  	    var res = u;

  	    if (u.cmp(this.m) >= 0) {
  	      res = u.isub(this.m);
  	    } else if (u.cmpn(0) < 0) {
  	      res = u.iadd(this.m);
  	    }

  	    return res._forceRed(this);
  	  };

  	  Mont.prototype.mul = function mul (a, b) {
  	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

  	    var t = a.mul(b);
  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
  	    var u = t.isub(c).iushrn(this.shift);
  	    var res = u;
  	    if (u.cmp(this.m) >= 0) {
  	      res = u.isub(this.m);
  	    } else if (u.cmpn(0) < 0) {
  	      res = u.iadd(this.m);
  	    }

  	    return res._forceRed(this);
  	  };

  	  Mont.prototype.invm = function invm (a) {
  	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
  	    var res = this.imod(a._invmp(this.m).mul(this.r2));
  	    return res._forceRed(this);
  	  };
  	})(module, commonjsGlobal); 
  } (bn));

  var bnExports = bn.exports;
  var BN = /*@__PURE__*/getDefaultExportFromCjs(bnExports);

  var long = Long;

  /**
   * wasm optimizations, to do native i64 multiplication and divide
   */
  var wasm = null;

  try {
    wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
      0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
    ])), {}).exports;
  } catch (e) {
    // no wasm support :(
  }

  /**
   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
   *  See the from* functions below for more convenient ways of constructing Longs.
   * @exports Long
   * @class A Long class for representing a 64 bit two's-complement integer value.
   * @param {number} low The low (signed) 32 bits of the long
   * @param {number} high The high (signed) 32 bits of the long
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @constructor
   */
  function Long(low, high, unsigned) {

      /**
       * The low 32 bits as a signed value.
       * @type {number}
       */
      this.low = low | 0;

      /**
       * The high 32 bits as a signed value.
       * @type {number}
       */
      this.high = high | 0;

      /**
       * Whether unsigned or not.
       * @type {boolean}
       */
      this.unsigned = !!unsigned;
  }

  // The internal representation of a long is the two given signed, 32-bit values.
  // We use 32-bit pieces because these are the size of integers on which
  // Javascript performs bit-operations.  For operations like addition and
  // multiplication, we split each number into 16 bit pieces, which can easily be
  // multiplied within Javascript's floating-point representation without overflow
  // or change in sign.
  //
  // In the algorithms below, we frequently reduce the negative case to the
  // positive case by negating the input(s) and then post-processing the result.
  // Note that we must ALWAYS check specially whether those values are MIN_VALUE
  // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
  // a positive number, it overflows back into a negative).  Not handling this
  // case would often result in infinite recursion.
  //
  // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
  // methods on which they depend.

  /**
   * An indicator used to reliably determine if an object is a Long or not.
   * @type {boolean}
   * @const
   * @private
   */
  Long.prototype.__isLong__;

  Object.defineProperty(Long.prototype, "__isLong__", { value: true });

  /**
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   * @inner
   */
  function isLong$1(obj) {
      return (obj && obj["__isLong__"]) === true;
  }

  /**
   * Tests if the specified object is a Long.
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   */
  Long.isLong = isLong$1;

  /**
   * A cache of the Long representations of small integer values.
   * @type {!Object}
   * @inner
   */
  var INT_CACHE = {};

  /**
   * A cache of the Long representations of small unsigned integer values.
   * @type {!Object}
   * @inner
   */
  var UINT_CACHE = {};

  /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */
  function fromInt(value, unsigned) {
      var obj, cachedObj, cache;
      if (unsigned) {
          value >>>= 0;
          if (cache = (0 <= value && value < 256)) {
              cachedObj = UINT_CACHE[value];
              if (cachedObj)
                  return cachedObj;
          }
          obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
          if (cache)
              UINT_CACHE[value] = obj;
          return obj;
      } else {
          value |= 0;
          if (cache = (-128 <= value && value < 128)) {
              cachedObj = INT_CACHE[value];
              if (cachedObj)
                  return cachedObj;
          }
          obj = fromBits(value, value < 0 ? -1 : 0, false);
          if (cache)
              INT_CACHE[value] = obj;
          return obj;
      }
  }

  /**
   * Returns a Long representing the given 32 bit integer value.
   * @function
   * @param {number} value The 32 bit integer in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */
  Long.fromInt = fromInt;

  /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */
  function fromNumber(value, unsigned) {
      if (isNaN(value))
          return unsigned ? UZERO : ZERO;
      if (unsigned) {
          if (value < 0)
              return UZERO;
          if (value >= TWO_PWR_64_DBL)
              return MAX_UNSIGNED_VALUE;
      } else {
          if (value <= -TWO_PWR_63_DBL)
              return MIN_VALUE;
          if (value + 1 >= TWO_PWR_63_DBL)
              return MAX_VALUE;
      }
      if (value < 0)
          return fromNumber(-value, unsigned).neg();
      return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
  }

  /**
   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
   * @function
   * @param {number} value The number in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */
  Long.fromNumber = fromNumber;

  /**
   * @param {number} lowBits
   * @param {number} highBits
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */
  function fromBits(lowBits, highBits, unsigned) {
      return new Long(lowBits, highBits, unsigned);
  }

  /**
   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
   *  assumed to use 32 bits.
   * @function
   * @param {number} lowBits The low 32 bits
   * @param {number} highBits The high 32 bits
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */
  Long.fromBits = fromBits;

  /**
   * @function
   * @param {number} base
   * @param {number} exponent
   * @returns {number}
   * @inner
   */
  var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

  /**
   * @param {string} str
   * @param {(boolean|number)=} unsigned
   * @param {number=} radix
   * @returns {!Long}
   * @inner
   */
  function fromString(str, unsigned, radix) {
      if (str.length === 0)
          throw Error('empty string');
      if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
          return ZERO;
      if (typeof unsigned === 'number') {
          // For goog.math.long compatibility
          radix = unsigned,
          unsigned = false;
      } else {
          unsigned = !! unsigned;
      }
      radix = radix || 10;
      if (radix < 2 || 36 < radix)
          throw RangeError('radix');

      var p;
      if ((p = str.indexOf('-')) > 0)
          throw Error('interior hyphen');
      else if (p === 0) {
          return fromString(str.substring(1), unsigned, radix).neg();
      }

      // Do several (8) digits each time through the loop, so as to
      // minimize the calls to the very expensive emulated div.
      var radixToPower = fromNumber(pow_dbl(radix, 8));

      var result = ZERO;
      for (var i = 0; i < str.length; i += 8) {
          var size = Math.min(8, str.length - i),
              value = parseInt(str.substring(i, i + size), radix);
          if (size < 8) {
              var power = fromNumber(pow_dbl(radix, size));
              result = result.mul(power).add(fromNumber(value));
          } else {
              result = result.mul(radixToPower);
              result = result.add(fromNumber(value));
          }
      }
      result.unsigned = unsigned;
      return result;
  }

  /**
   * Returns a Long representation of the given string, written using the specified radix.
   * @function
   * @param {string} str The textual representation of the Long
   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
   * @returns {!Long} The corresponding Long value
   */
  Long.fromString = fromString;

  /**
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */
  function fromValue(val, unsigned) {
      if (typeof val === 'number')
          return fromNumber(val, unsigned);
      if (typeof val === 'string')
          return fromString(val, unsigned);
      // Throws for non-objects, converts non-instanceof Long:
      return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
  }

  /**
   * Converts the specified value to a Long using the appropriate from* function for its type.
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long}
   */
  Long.fromValue = fromValue;

  // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
  // no runtime penalty for these.

  /**
   * @type {number}
   * @const
   * @inner
   */
  var TWO_PWR_16_DBL = 1 << 16;

  /**
   * @type {number}
   * @const
   * @inner
   */
  var TWO_PWR_24_DBL = 1 << 24;

  /**
   * @type {number}
   * @const
   * @inner
   */
  var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

  /**
   * @type {number}
   * @const
   * @inner
   */
  var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

  /**
   * @type {number}
   * @const
   * @inner
   */
  var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

  /**
   * @type {!Long}
   * @const
   * @inner
   */
  var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

  /**
   * @type {!Long}
   * @inner
   */
  var ZERO = fromInt(0);

  /**
   * Signed zero.
   * @type {!Long}
   */
  Long.ZERO = ZERO;

  /**
   * @type {!Long}
   * @inner
   */
  var UZERO = fromInt(0, true);

  /**
   * Unsigned zero.
   * @type {!Long}
   */
  Long.UZERO = UZERO;

  /**
   * @type {!Long}
   * @inner
   */
  var ONE = fromInt(1);

  /**
   * Signed one.
   * @type {!Long}
   */
  Long.ONE = ONE;

  /**
   * @type {!Long}
   * @inner
   */
  var UONE = fromInt(1, true);

  /**
   * Unsigned one.
   * @type {!Long}
   */
  Long.UONE = UONE;

  /**
   * @type {!Long}
   * @inner
   */
  var NEG_ONE = fromInt(-1);

  /**
   * Signed negative one.
   * @type {!Long}
   */
  Long.NEG_ONE = NEG_ONE;

  /**
   * @type {!Long}
   * @inner
   */
  var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

  /**
   * Maximum signed value.
   * @type {!Long}
   */
  Long.MAX_VALUE = MAX_VALUE;

  /**
   * @type {!Long}
   * @inner
   */
  var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

  /**
   * Maximum unsigned value.
   * @type {!Long}
   */
  Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

  /**
   * @type {!Long}
   * @inner
   */
  var MIN_VALUE = fromBits(0, 0x80000000|0, false);

  /**
   * Minimum signed value.
   * @type {!Long}
   */
  Long.MIN_VALUE = MIN_VALUE;

  /**
   * @alias Long.prototype
   * @inner
   */
  var LongPrototype = Long.prototype;

  /**
   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
   * @returns {number}
   */
  LongPrototype.toInt = function toInt() {
      return this.unsigned ? this.low >>> 0 : this.low;
  };

  /**
   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
   * @returns {number}
   */
  LongPrototype.toNumber = function toNumber() {
      if (this.unsigned)
          return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
      return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
  };

  /**
   * Converts the Long to a string written in the specified radix.
   * @param {number=} radix Radix (2-36), defaults to 10
   * @returns {string}
   * @override
   * @throws {RangeError} If `radix` is out of range
   */
  LongPrototype.toString = function toString(radix) {
      radix = radix || 10;
      if (radix < 2 || 36 < radix)
          throw RangeError('radix');
      if (this.isZero())
          return '0';
      if (this.isNegative()) { // Unsigned Longs are never negative
          if (this.eq(MIN_VALUE)) {
              // We need to change the Long value before it can be negated, so we remove
              // the bottom-most digit in this base and then recurse to do the rest.
              var radixLong = fromNumber(radix),
                  div = this.div(radixLong),
                  rem1 = div.mul(radixLong).sub(this);
              return div.toString(radix) + rem1.toInt().toString(radix);
          } else
              return '-' + this.neg().toString(radix);
      }

      // Do several (6) digits each time through the loop, so as to
      // minimize the calls to the very expensive emulated div.
      var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
          rem = this;
      var result = '';
      while (true) {
          var remDiv = rem.div(radixToPower),
              intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
              digits = intval.toString(radix);
          rem = remDiv;
          if (rem.isZero())
              return digits + result;
          else {
              while (digits.length < 6)
                  digits = '0' + digits;
              result = '' + digits + result;
          }
      }
  };

  /**
   * Gets the high 32 bits as a signed integer.
   * @returns {number} Signed high bits
   */
  LongPrototype.getHighBits = function getHighBits() {
      return this.high;
  };

  /**
   * Gets the high 32 bits as an unsigned integer.
   * @returns {number} Unsigned high bits
   */
  LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
      return this.high >>> 0;
  };

  /**
   * Gets the low 32 bits as a signed integer.
   * @returns {number} Signed low bits
   */
  LongPrototype.getLowBits = function getLowBits() {
      return this.low;
  };

  /**
   * Gets the low 32 bits as an unsigned integer.
   * @returns {number} Unsigned low bits
   */
  LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
      return this.low >>> 0;
  };

  /**
   * Gets the number of bits needed to represent the absolute value of this Long.
   * @returns {number}
   */
  LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
      if (this.isNegative()) // Unsigned Longs are never negative
          return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
      var val = this.high != 0 ? this.high : this.low;
      for (var bit = 31; bit > 0; bit--)
          if ((val & (1 << bit)) != 0)
              break;
      return this.high != 0 ? bit + 33 : bit + 1;
  };

  /**
   * Tests if this Long's value equals zero.
   * @returns {boolean}
   */
  LongPrototype.isZero = function isZero() {
      return this.high === 0 && this.low === 0;
  };

  /**
   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
   * @returns {boolean}
   */
  LongPrototype.eqz = LongPrototype.isZero;

  /**
   * Tests if this Long's value is negative.
   * @returns {boolean}
   */
  LongPrototype.isNegative = function isNegative() {
      return !this.unsigned && this.high < 0;
  };

  /**
   * Tests if this Long's value is positive.
   * @returns {boolean}
   */
  LongPrototype.isPositive = function isPositive() {
      return this.unsigned || this.high >= 0;
  };

  /**
   * Tests if this Long's value is odd.
   * @returns {boolean}
   */
  LongPrototype.isOdd = function isOdd() {
      return (this.low & 1) === 1;
  };

  /**
   * Tests if this Long's value is even.
   * @returns {boolean}
   */
  LongPrototype.isEven = function isEven() {
      return (this.low & 1) === 0;
  };

  /**
   * Tests if this Long's value equals the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.equals = function equals(other) {
      if (!isLong$1(other))
          other = fromValue(other);
      if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
          return false;
      return this.high === other.high && this.low === other.low;
  };

  /**
   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.eq = LongPrototype.equals;

  /**
   * Tests if this Long's value differs from the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.notEquals = function notEquals(other) {
      return !this.eq(/* validates */ other);
  };

  /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.neq = LongPrototype.notEquals;

  /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.ne = LongPrototype.notEquals;

  /**
   * Tests if this Long's value is less than the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.lessThan = function lessThan(other) {
      return this.comp(/* validates */ other) < 0;
  };

  /**
   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.lt = LongPrototype.lessThan;

  /**
   * Tests if this Long's value is less than or equal the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
      return this.comp(/* validates */ other) <= 0;
  };

  /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.lte = LongPrototype.lessThanOrEqual;

  /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.le = LongPrototype.lessThanOrEqual;

  /**
   * Tests if this Long's value is greater than the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.greaterThan = function greaterThan(other) {
      return this.comp(/* validates */ other) > 0;
  };

  /**
   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.gt = LongPrototype.greaterThan;

  /**
   * Tests if this Long's value is greater than or equal the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
      return this.comp(/* validates */ other) >= 0;
  };

  /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.gte = LongPrototype.greaterThanOrEqual;

  /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */
  LongPrototype.ge = LongPrototype.greaterThanOrEqual;

  /**
   * Compares this Long's value with the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */
  LongPrototype.compare = function compare(other) {
      if (!isLong$1(other))
          other = fromValue(other);
      if (this.eq(other))
          return 0;
      var thisNeg = this.isNegative(),
          otherNeg = other.isNegative();
      if (thisNeg && !otherNeg)
          return -1;
      if (!thisNeg && otherNeg)
          return 1;
      // At this point the sign bits are the same
      if (!this.unsigned)
          return this.sub(other).isNegative() ? -1 : 1;
      // Both are positive if at least one is unsigned
      return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
  };

  /**
   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */
  LongPrototype.comp = LongPrototype.compare;

  /**
   * Negates this Long's value.
   * @returns {!Long} Negated Long
   */
  LongPrototype.negate = function negate() {
      if (!this.unsigned && this.eq(MIN_VALUE))
          return MIN_VALUE;
      return this.not().add(ONE);
  };

  /**
   * Negates this Long's value. This is an alias of {@link Long#negate}.
   * @function
   * @returns {!Long} Negated Long
   */
  LongPrototype.neg = LongPrototype.negate;

  /**
   * Returns the sum of this and the specified Long.
   * @param {!Long|number|string} addend Addend
   * @returns {!Long} Sum
   */
  LongPrototype.add = function add(addend) {
      if (!isLong$1(addend))
          addend = fromValue(addend);

      // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

      var a48 = this.high >>> 16;
      var a32 = this.high & 0xFFFF;
      var a16 = this.low >>> 16;
      var a00 = this.low & 0xFFFF;

      var b48 = addend.high >>> 16;
      var b32 = addend.high & 0xFFFF;
      var b16 = addend.low >>> 16;
      var b00 = addend.low & 0xFFFF;

      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
      c00 += a00 + b00;
      c16 += c00 >>> 16;
      c00 &= 0xFFFF;
      c16 += a16 + b16;
      c32 += c16 >>> 16;
      c16 &= 0xFFFF;
      c32 += a32 + b32;
      c48 += c32 >>> 16;
      c32 &= 0xFFFF;
      c48 += a48 + b48;
      c48 &= 0xFFFF;
      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
  };

  /**
   * Returns the difference of this and the specified Long.
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */
  LongPrototype.subtract = function subtract(subtrahend) {
      if (!isLong$1(subtrahend))
          subtrahend = fromValue(subtrahend);
      return this.add(subtrahend.neg());
  };

  /**
   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
   * @function
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */
  LongPrototype.sub = LongPrototype.subtract;

  /**
   * Returns the product of this and the specified Long.
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */
  LongPrototype.multiply = function multiply(multiplier) {
      if (this.isZero())
          return ZERO;
      if (!isLong$1(multiplier))
          multiplier = fromValue(multiplier);

      // use wasm support if present
      if (wasm) {
          var low = wasm.mul(this.low,
                             this.high,
                             multiplier.low,
                             multiplier.high);
          return fromBits(low, wasm.get_high(), this.unsigned);
      }

      if (multiplier.isZero())
          return ZERO;
      if (this.eq(MIN_VALUE))
          return multiplier.isOdd() ? MIN_VALUE : ZERO;
      if (multiplier.eq(MIN_VALUE))
          return this.isOdd() ? MIN_VALUE : ZERO;

      if (this.isNegative()) {
          if (multiplier.isNegative())
              return this.neg().mul(multiplier.neg());
          else
              return this.neg().mul(multiplier).neg();
      } else if (multiplier.isNegative())
          return this.mul(multiplier.neg()).neg();

      // If both longs are small, use float multiplication
      if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
          return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

      // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
      // We can skip products that would overflow.

      var a48 = this.high >>> 16;
      var a32 = this.high & 0xFFFF;
      var a16 = this.low >>> 16;
      var a00 = this.low & 0xFFFF;

      var b48 = multiplier.high >>> 16;
      var b32 = multiplier.high & 0xFFFF;
      var b16 = multiplier.low >>> 16;
      var b00 = multiplier.low & 0xFFFF;

      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
      c00 += a00 * b00;
      c16 += c00 >>> 16;
      c00 &= 0xFFFF;
      c16 += a16 * b00;
      c32 += c16 >>> 16;
      c16 &= 0xFFFF;
      c16 += a00 * b16;
      c32 += c16 >>> 16;
      c16 &= 0xFFFF;
      c32 += a32 * b00;
      c48 += c32 >>> 16;
      c32 &= 0xFFFF;
      c32 += a16 * b16;
      c48 += c32 >>> 16;
      c32 &= 0xFFFF;
      c32 += a00 * b32;
      c48 += c32 >>> 16;
      c32 &= 0xFFFF;
      c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
      c48 &= 0xFFFF;
      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
  };

  /**
   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
   * @function
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */
  LongPrototype.mul = LongPrototype.multiply;

  /**
   * Returns this Long divided by the specified. The result is signed if this Long is signed or
   *  unsigned if this Long is unsigned.
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */
  LongPrototype.divide = function divide(divisor) {
      if (!isLong$1(divisor))
          divisor = fromValue(divisor);
      if (divisor.isZero())
          throw Error('division by zero');

      // use wasm support if present
      if (wasm) {
          // guard against signed division overflow: the largest
          // negative number / -1 would be 1 larger than the largest
          // positive number, due to two's complement.
          if (!this.unsigned &&
              this.high === -0x80000000 &&
              divisor.low === -1 && divisor.high === -1) {
              // be consistent with non-wasm code path
              return this;
          }
          var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
              this.low,
              this.high,
              divisor.low,
              divisor.high
          );
          return fromBits(low, wasm.get_high(), this.unsigned);
      }

      if (this.isZero())
          return this.unsigned ? UZERO : ZERO;
      var approx, rem, res;
      if (!this.unsigned) {
          // This section is only relevant for signed longs and is derived from the
          // closure library as a whole.
          if (this.eq(MIN_VALUE)) {
              if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                  return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
              else if (divisor.eq(MIN_VALUE))
                  return ONE;
              else {
                  // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                  var halfThis = this.shr(1);
                  approx = halfThis.div(divisor).shl(1);
                  if (approx.eq(ZERO)) {
                      return divisor.isNegative() ? ONE : NEG_ONE;
                  } else {
                      rem = this.sub(divisor.mul(approx));
                      res = approx.add(rem.div(divisor));
                      return res;
                  }
              }
          } else if (divisor.eq(MIN_VALUE))
              return this.unsigned ? UZERO : ZERO;
          if (this.isNegative()) {
              if (divisor.isNegative())
                  return this.neg().div(divisor.neg());
              return this.neg().div(divisor).neg();
          } else if (divisor.isNegative())
              return this.div(divisor.neg()).neg();
          res = ZERO;
      } else {
          // The algorithm below has not been made for unsigned longs. It's therefore
          // required to take special care of the MSB prior to running it.
          if (!divisor.unsigned)
              divisor = divisor.toUnsigned();
          if (divisor.gt(this))
              return UZERO;
          if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
              return UONE;
          res = UZERO;
      }

      // Repeat the following until the remainder is less than other:  find a
      // floating-point that approximates remainder / other *from below*, add this
      // into the result, and subtract it from the remainder.  It is critical that
      // the approximate value is less than or equal to the real value so that the
      // remainder never becomes negative.
      rem = this;
      while (rem.gte(divisor)) {
          // Approximate the result of division. This may be a little greater or
          // smaller than the actual value.
          approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

          // We will tweak the approximate result by changing it in the 48-th digit or
          // the smallest non-fractional digit, whichever is larger.
          var log2 = Math.ceil(Math.log(approx) / Math.LN2),
              delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

          // Decrease the approximation until it is smaller than the remainder.  Note
          // that if it is too large, the product overflows and is negative.
              approxRes = fromNumber(approx),
              approxRem = approxRes.mul(divisor);
          while (approxRem.isNegative() || approxRem.gt(rem)) {
              approx -= delta;
              approxRes = fromNumber(approx, this.unsigned);
              approxRem = approxRes.mul(divisor);
          }

          // We know the answer can't be zero... and actually, zero would cause
          // infinite recursion since we would make no progress.
          if (approxRes.isZero())
              approxRes = ONE;

          res = res.add(approxRes);
          rem = rem.sub(approxRem);
      }
      return res;
  };

  /**
   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */
  LongPrototype.div = LongPrototype.divide;

  /**
   * Returns this Long modulo the specified.
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */
  LongPrototype.modulo = function modulo(divisor) {
      if (!isLong$1(divisor))
          divisor = fromValue(divisor);

      // use wasm support if present
      if (wasm) {
          var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
              this.low,
              this.high,
              divisor.low,
              divisor.high
          );
          return fromBits(low, wasm.get_high(), this.unsigned);
      }

      return this.sub(this.div(divisor).mul(divisor));
  };

  /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */
  LongPrototype.mod = LongPrototype.modulo;

  /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */
  LongPrototype.rem = LongPrototype.modulo;

  /**
   * Returns the bitwise NOT of this Long.
   * @returns {!Long}
   */
  LongPrototype.not = function not() {
      return fromBits(~this.low, ~this.high, this.unsigned);
  };

  /**
   * Returns the bitwise AND of this Long and the specified.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */
  LongPrototype.and = function and(other) {
      if (!isLong$1(other))
          other = fromValue(other);
      return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
  };

  /**
   * Returns the bitwise OR of this Long and the specified.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */
  LongPrototype.or = function or(other) {
      if (!isLong$1(other))
          other = fromValue(other);
      return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
  };

  /**
   * Returns the bitwise XOR of this Long and the given one.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */
  LongPrototype.xor = function xor(other) {
      if (!isLong$1(other))
          other = fromValue(other);
      return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
  };

  /**
   * Returns this Long with bits shifted to the left by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shiftLeft = function shiftLeft(numBits) {
      if (isLong$1(numBits))
          numBits = numBits.toInt();
      if ((numBits &= 63) === 0)
          return this;
      else if (numBits < 32)
          return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
      else
          return fromBits(0, this.low << (numBits - 32), this.unsigned);
  };

  /**
   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shl = LongPrototype.shiftLeft;

  /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shiftRight = function shiftRight(numBits) {
      if (isLong$1(numBits))
          numBits = numBits.toInt();
      if ((numBits &= 63) === 0)
          return this;
      else if (numBits < 32)
          return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
      else
          return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
  };

  /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shr = LongPrototype.shiftRight;

  /**
   * Returns this Long with bits logically shifted to the right by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
      if (isLong$1(numBits))
          numBits = numBits.toInt();
      numBits &= 63;
      if (numBits === 0)
          return this;
      else {
          var high = this.high;
          if (numBits < 32) {
              var low = this.low;
              return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
          } else if (numBits === 32)
              return fromBits(high, 0, this.unsigned);
          else
              return fromBits(high >>> (numBits - 32), 0, this.unsigned);
      }
  };

  /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shru = LongPrototype.shiftRightUnsigned;

  /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */
  LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

  /**
   * Converts this Long to signed.
   * @returns {!Long} Signed long
   */
  LongPrototype.toSigned = function toSigned() {
      if (!this.unsigned)
          return this;
      return fromBits(this.low, this.high, false);
  };

  /**
   * Converts this Long to unsigned.
   * @returns {!Long} Unsigned long
   */
  LongPrototype.toUnsigned = function toUnsigned() {
      if (this.unsigned)
          return this;
      return fromBits(this.low, this.high, true);
  };

  /**
   * Converts this Long to its byte representation.
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {!Array.<number>} Byte representation
   */
  LongPrototype.toBytes = function toBytes(le) {
      return le ? this.toBytesLE() : this.toBytesBE();
  };

  /**
   * Converts this Long to its little endian byte representation.
   * @returns {!Array.<number>} Little endian byte representation
   */
  LongPrototype.toBytesLE = function toBytesLE() {
      var hi = this.high,
          lo = this.low;
      return [
          lo        & 0xff,
          lo >>>  8 & 0xff,
          lo >>> 16 & 0xff,
          lo >>> 24       ,
          hi        & 0xff,
          hi >>>  8 & 0xff,
          hi >>> 16 & 0xff,
          hi >>> 24
      ];
  };

  /**
   * Converts this Long to its big endian byte representation.
   * @returns {!Array.<number>} Big endian byte representation
   */
  LongPrototype.toBytesBE = function toBytesBE() {
      var hi = this.high,
          lo = this.low;
      return [
          hi >>> 24       ,
          hi >>> 16 & 0xff,
          hi >>>  8 & 0xff,
          hi        & 0xff,
          lo >>> 24       ,
          lo >>> 16 & 0xff,
          lo >>>  8 & 0xff,
          lo        & 0xff
      ];
  };

  /**
   * Creates a Long from its byte representation.
   * @param {!Array.<number>} bytes Byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {Long} The corresponding Long value
   */
  Long.fromBytes = function fromBytes(bytes, unsigned, le) {
      return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
  };

  /**
   * Creates a Long from its little endian byte representation.
   * @param {!Array.<number>} bytes Little endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */
  Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
      return new Long(
          bytes[0]       |
          bytes[1] <<  8 |
          bytes[2] << 16 |
          bytes[3] << 24,
          bytes[4]       |
          bytes[5] <<  8 |
          bytes[6] << 16 |
          bytes[7] << 24,
          unsigned
      );
  };

  /**
   * Creates a Long from its big endian byte representation.
   * @param {!Array.<number>} bytes Big endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */
  Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
      return new Long(
          bytes[4] << 24 |
          bytes[5] << 16 |
          bytes[6] <<  8 |
          bytes[7],
          bytes[0] << 24 |
          bytes[1] << 16 |
          bytes[2] <<  8 |
          bytes[3],
          unsigned
      );
  };

  var Long$1 = /*@__PURE__*/getDefaultExportFromCjs(long);

  //  Copyright (C) 2018 Zilliqa
  var isAddress = function (address) {
      return isByteString(address, 40);
  };
  var isBech32 = function (raw) {
      return !!raw.match(/^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$/);
  };
  var isBase58 = function (raw) {
      return !!raw.match(/^[1-9ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]+$/);
  };
  var isPrivateKey = function (privateKey) {
      return isByteString(privateKey, 64);
  };
  var isPubKey = function (pubKey) {
      return isByteString(pubKey, 66);
  };
  var isSignature = function (sig) {
      return isByteString(sig, 128);
  };
  var isByteString = function (str, len) {
      return !!str.replace('0x', '').match("^[0-9a-fA-F]{".concat(len, "}$"));
  };
  var isNumber = function (x) {
      return typeof x === 'number';
  };
  var isBN = function (x) {
      return BN.isBN(x);
  };
  var isLong = function (x) {
      return Long$1.isLong(x);
  };
  var isString = function (x) {
      return typeof x === 'string';
  };
  var isPlainObject = function (x) {
      if (typeof x === 'object' && x !== null) {
          var proto = Object.getPrototypeOf(x);
          return proto === Object.prototype || proto === null;
      }
      return false;
  };
  var PRAGMA_REQUIRED = '@@ZJS_REQUIRED@@';
  var required = function (fn) {
      if (typeof fn === 'function') {
          return Object.defineProperty(fn, 'required', {
              value: PRAGMA_REQUIRED,
          });
      }
      throw new Error('fn is not a function');
  };
  var matchesObject = function (x, test) {
      var e_1, _a;
      if (isPlainObject(x)) {
          for (var key in test) {
              if (test.hasOwnProperty(key)) {
                  try {
                      for (var _b = (e_1 = void 0, __values(test[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
                          var tester = _c.value;
                          var value = x[key];
                          if (typeof value === 'undefined' && tester.required) {
                              throw new Error('Key not found: ' + key);
                          }
                          else {
                              continue;
                          }
                      }
                  }
                  catch (e_1_1) { e_1 = { error: e_1_1 }; }
                  finally {
                      try {
                          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                      }
                      finally { if (e_1) throw e_1.error; }
                  }
              }
          }
      }
      return true;
  };

  var validation = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isAddress: isAddress,
    isBech32: isBech32,
    isBase58: isBase58,
    isPrivateKey: isPrivateKey,
    isPubKey: isPubKey,
    isSignature: isSignature,
    isByteString: isByteString,
    isNumber: isNumber,
    isBN: isBN,
    isLong: isLong,
    isString: isString,
    isPlainObject: isPlainObject,
    required: required,
    matchesObject: matchesObject
  });

  //  Copyright (C) 2018 Zilliqa
  var Units;
  (function (Units) {
      Units["Zil"] = "zil";
      Units["Li"] = "li";
      Units["Qa"] = "qa";
  })(Units || (Units = {}));
  var DEFAULT_OPTIONS = {
      pad: false,
  };
  var unitMap = new Map([
      [Units.Qa, '1'],
      [Units.Li, '1000000'],
      [Units.Zil, '1000000000000'], // 1e12 qa
  ]);
  var numToStr = function (input) {
      if (typeof input === 'string') {
          if (!input.match(/^-?[0-9.]+$/)) {
              throw new Error("while converting number to string, invalid number value '".concat(input, "', should be a number matching (^-?[0-9.]+)."));
          }
          return input;
      }
      else if (typeof input === 'number') {
          return String(input);
      }
      else if (BN.isBN(input)) {
          return input.toString(10);
      }
      throw new Error("while converting number to string, invalid number value '".concat(input, "' type ").concat(typeof input, "."));
  };
  var fromQa = function (qa, unit, options) {
      if (options === void 0) { options = DEFAULT_OPTIONS; }
      if (unit === 'qa') {
          return qa.toString(10);
      }
      var baseStr = unitMap.get(unit);
      if (!baseStr) {
          throw new Error("No unit of type ".concat(unit, " exists."));
      }
      var base = new BN(baseStr, 10);
      var baseNumDecimals = baseStr.length - 1;
      var fraction = qa.abs().mod(base).toString(10);
      // prepend 0s to the fraction half
      while (fraction.length < baseNumDecimals) {
          fraction = "0".concat(fraction);
      }
      if (!options.pad) {
          fraction = (fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1]);
      }
      var whole = qa.div(base).toString(10);
      return fraction === '0' ? "".concat(whole) : "".concat(whole, ".").concat(fraction);
  };
  var toQa = function (input, unit) {
      var inputStr = numToStr(input);
      var baseStr = unitMap.get(unit);
      if (!baseStr) {
          throw new Error("No unit of type ".concat(unit, " exists."));
      }
      var baseNumDecimals = baseStr.length - 1;
      var base = new BN(baseStr, 10);
      // Is it negative?
      var isNegative = inputStr.substring(0, 1) === '-';
      if (isNegative) {
          inputStr = inputStr.substring(1);
      }
      if (inputStr === '.') {
          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
      }
      // Split it into a whole and fractional part
      var comps = inputStr.split('.'); // eslint-disable-line
      if (comps.length > 2) {
          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
      }
      var _a = __read(comps, 2), whole = _a[0], fraction = _a[1];
      if (!whole) {
          whole = '0';
      }
      if (!fraction) {
          fraction = '0';
      }
      if (fraction.length > baseNumDecimals) {
          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
      }
      while (fraction.length < baseNumDecimals) {
          fraction += '0';
      }
      var wholeBN = new BN(whole);
      var fractionBN = new BN(fraction);
      var wei = wholeBN.mul(base).add(fractionBN); // eslint-disable-line
      if (isNegative) {
          wei = wei.neg();
      }
      return new BN(wei.toString(10), 10);
  };

  var unit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get Units () { return Units; },
    fromQa: fromQa,
    toQa: toQa
  });

  exports.BN = BN;
  exports.Long = Long$1;
  exports.bytes = bytes;
  exports.units = unit;
  exports.validation = validation;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=bundle.js.map
